import { svg } from 'lit';

import { AMBIENT_SCRIBE_SVG } from '../../src/svg/ambient-scribe';

export const RENDERER_SVGS = {
  accountCircle: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
    `,
  },
  accounts: {
    viewBox: '0 0 60 60',
    src: svg`
      <path d="M55.517,46.55l-9.773-4.233c-0.23-0.115-0.485-0.396-0.704-0.771l6.525-0.005c0.114,0.011,2.804,0.257,4.961-0.67 c0.817-0.352,1.425-1.047,1.669-1.907c0.246-0.868,0.09-1.787-0.426-2.523c-1.865-2.654-6.218-9.589-6.354-16.623 c-0.003-0.121-0.397-12.083-12.21-12.18c-1.739,0.014-3.347,0.309-4.81,0.853c-0.319-0.813-0.789-1.661-1.488-2.459 C30.854,3.688,27.521,2.5,23,2.5s-7.854,1.188-9.908,3.53c-2.368,2.701-2.148,5.976-2.092,6.525v5.319c-0.64,0.729-1,1.662-1,2.625 v4c0,1.217,0.553,2.352,1.497,3.109c0.916,3.627,2.833,6.36,3.503,7.237v3.309c0,0.968-0.528,1.856-1.377,2.32l-8.921,4.866 C1.801,46.924,0,49.958,0,53.262V57.5h44h2h14v-3.697C60,50.711,58.282,47.933,55.517,46.55z M44,55.5H2v-2.238 c0-2.571,1.402-4.934,3.659-6.164l8.921-4.866C16.073,41.417,17,39.854,17,38.155v-4.019l-0.233-0.278 c-0.024-0.029-2.475-2.994-3.41-7.065l-0.091-0.396l-0.341-0.22C12.346,25.803,12,25.176,12,24.5v-4c0-0.561,0.238-1.084,0.67-1.475 L13,18.728V12.5l-0.009-0.131c-0.003-0.027-0.343-2.799,1.605-5.021C16.253,5.458,19.081,4.5,23,4.5 c3.905,0,6.727,0.951,8.386,2.828c0.825,0.932,1.24,1.973,1.447,2.867c0.016,0.07,0.031,0.139,0.045,0.208 c0.014,0.071,0.029,0.142,0.04,0.21c0.013,0.078,0.024,0.152,0.035,0.226c0.008,0.053,0.016,0.107,0.022,0.158 c0.015,0.124,0.027,0.244,0.035,0.355c0.001,0.009,0.001,0.017,0.001,0.026c0.007,0.108,0.012,0.21,0.015,0.303 c0,0.018,0,0.033,0.001,0.051c0.002,0.083,0.002,0.162,0.001,0.231c0,0.01,0,0.02,0,0.03c-0.004,0.235-0.02,0.375-0.02,0.378 L33,18.728l0.33,0.298C33.762,19.416,34,19.939,34,20.5v4c0,0.873-0.572,1.637-1.422,1.899l-0.498,0.153l-0.16,0.495 c-0.669,2.081-1.622,4.003-2.834,5.713c-0.297,0.421-0.586,0.794-0.837,1.079L28,34.123v4.125c0,0.253,0.025,0.501,0.064,0.745 c0.008,0.052,0.022,0.102,0.032,0.154c0.039,0.201,0.091,0.398,0.155,0.59c0.015,0.045,0.031,0.088,0.048,0.133 c0.078,0.209,0.169,0.411,0.275,0.605c0.012,0.022,0.023,0.045,0.035,0.067c0.145,0.256,0.312,0.499,0.504,0.723l0.228,0.281h0.039 c0.343,0.338,0.737,0.632,1.185,0.856l9.553,4.776C42.513,48.374,44,50.78,44,53.457V55.5z M58,55.5H46v-2.043 c0-3.439-1.911-6.53-4.986-8.068l-6.858-3.43c0.169-0.386,0.191-0.828,0.043-1.254c-0.245-0.705-0.885-1.16-1.63-1.16h-2.217 c-0.046-0.081-0.076-0.17-0.113-0.256c-0.05-0.115-0.109-0.228-0.142-0.349C30.036,38.718,30,38.486,30,38.248v-3.381 c0.229-0.28,0.47-0.599,0.719-0.951c1.239-1.75,2.232-3.698,2.954-5.799C35.084,27.47,36,26.075,36,24.5v-4 c0-0.963-0.36-1.896-1-2.625v-5.319c0.026-0.25,0.082-1.069-0.084-2.139c1.288-0.506,2.731-0.767,4.29-0.78 c9.841,0.081,10.2,9.811,10.21,10.221c0.147,7.583,4.746,14.927,6.717,17.732c0.169,0.24,0.22,0.542,0.139,0.827 c-0.046,0.164-0.178,0.462-0.535,0.615c-1.68,0.723-3.959,0.518-4.076,0.513h-6.883c-0.643,0-1.229,0.327-1.568,0.874 c-0.338,0.545-0.37,1.211-0.086,1.783c0.313,0.631,0.866,1.474,1.775,1.927l9.747,4.222C56.715,49.396,58,51.482,58,53.803V55.5z"/>
    `,
  },
  addNote: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M10.2,22.7h8.4c1.3,0,2.4-1.1,2.4-2.4l0-16.9C21.1,2.1,20,1,18.7,1H5.4C4.1,1,3,2.1,3,3.4v12L10.2,22.7z M18.7,3.4v16.9
    h-7.2v-6h-6V3.4H18.7z"/>`,
  },
  agenda: {
    viewBox: '0 0 60 60',
    src: svg`
      <circle cx="7.3" cy="10.07" r="4.14"/><line class="line" x1="19.41" y1="10.07" x2="55.16" y2="10.07"/>
      <circle cx="7.3" cy="29.09" r="4.14"/><line class="line" x1="19.41" y1="29.09" x2="55.16" y2="29.09"/>
      <circle cx="7.3" cy="48.11" r="4.14"/><line class="line" x1="19.41" y1="48.11" x2="55.16" y2="48.11"/>
    `,
  },
  allocate: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/>
      <path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
    `,
  },
  ambientScribe: {
    viewBox: '0 0 24 24',
    src: AMBIENT_SCRIBE_SVG,
  },
  analytics: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"/>
    `,
  },
  arrived: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M12 2c3.86 0 7 3.14 7 7 0 5.25-7 13-7 13S5 14.25 5 9c0-3.86 3.14-7 7-7zm-1.53 12L17 7.41 15.6 6l-5.13 5.18L8.4 9.09 7 10.5l3.47 3.5z"/>
    `,
  },
  arrow: {
    viewBox: '0 0 56 28',
    src: svg`<polygon points="28 28 56 0 0 0 28 28"/>`,
  },
  arrowBack: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"/>`,
  },
  back: {
    viewBox: '0 0 60 60',
    src: svg`<path d="M4.83,30,31.41,3.41A2,2,0,0,0,28.59.59l-28,28a2,2,0,0,0,0,2.83l28,28a2,2,0,1,0,2.83-2.83Z"/>`,
  },
  batch: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M24 0h-24v24H24z" fill="none"/>
      <path d="M10 2H20c1.11 0 2 .9 2 2v10h-2V4h-10V2zm-4 4H16c1.11 0 2 .9 2 2v10h-2V8h-10V6zm-2 4h8c1.11 0 2 .9 2 2v8c0 1.1-.89 2-2 2h-8c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2z"/>
    `,
  },
  billSingle: {
    viewBox: '0 0 29.498 17.618',
    src: svg`
      <path d="M28.565,182.2H.933a.936.936,0,0,0-.933.933v15.752a.936.936,0,0,0,.933.933H28.565a.936.936,0,0,0,.933-.933V183.133A.936.936,0,0,0,28.565,182.2Zm-.933,15.752H1.866V184.066H27.632Z" transform="translate(0 -182.2)"/>
      <path d="M69.733,285.066H72.05a.933.933,0,0,0,0-1.866H69.733a.933.933,0,1,0,0,1.866Z" transform="translate(-63.451 -275.347)"/>
      <path d="M257.733,285.066h2.317a.933.933,0,0,0,0-1.866h-2.317a.933.933,0,0,0,0,1.866Z" transform="translate(-236.834 -275.347)"/>
      <path d="M150.235,229.193H151.7a.669.669,0,0,1,0,1.337h-2.62a.933.933,0,0,0,0,1.866h.956v.614a.933.933,0,0,0,1.866,0v-.622a2.535,2.535,0,0,0-.2-5.061h-1.462a.669.669,0,1,1,0-1.337h2.573a.933.933,0,0,0,0-1.866h-.91v-.591a.933.933,0,1,0-1.866,0v.606a2.531,2.531,0,0,0,.2,5.054Z" transform="translate(-136.217 -219.459)"/>
    `,
  },
  billMultiple: {
    viewBox: '0 0 31.2 21.592',
    src: svg`
      <path d="M23.723,182.2H.775a.777.777,0,0,0-.775.775v13.082a.777.777,0,0,0,.775.775H23.723a.777.777,0,0,0,.775-.775V182.975A.777.777,0,0,0,23.723,182.2Zm-.775,13.082H1.55V183.75h21.4Z" transform="translate(0 -175.239)"/>
      <path d="M69.575,284.75H71.5a.775.775,0,0,0,0-1.55H69.575a.775.775,0,0,0,0,1.55Z" transform="translate(-64.358 -269.718)"/>
      <path d="M75.523,128.1H52.575a.775.775,0,1,0,0,1.55H74.748v12.307a.775.775,0,1,0,1.55,0V128.875A.777.777,0,0,0,75.523,128.1Z" transform="translate(-48.455 -124.633)"/>
      <path d="M127.523,74.4H104.575a.775.775,0,0,0,0,1.55h22.173V88.257a.775.775,0,0,0,1.55,0V75.175A.777.777,0,0,0,127.523,74.4Z" transform="translate(-97.098 -74.4)"/>
      <path d="M257.575,284.75H259.5a.775.775,0,1,0,0-1.55h-1.924a.775.775,0,1,0,0,1.55Z" transform="translate(-240.219 -269.718)"/>
      <path d="M149.8,228.075h1.214a.555.555,0,0,1,0,1.111h-2.176a.775.775,0,0,0,0,1.55h.794v.51a.775.775,0,1,0,1.55,0v-.517a2.105,2.105,0,0,0-.168-4.2H149.8a.555.555,0,0,1,0-1.111h2.137a.775.775,0,0,0,0-1.55h-.755v-.491a.775.775,0,1,0-1.55,0v.5a2.1,2.1,0,0,0,.168,4.2Z" transform="translate(-138.163 -213.031)"/>
    `,
  },
  billDollarSign: {
    viewBox: '0 0 30.525 27.999',
    src: svg`
      <path d="M26.424,24.214A14,14,0,0,0,6.5,24.34a.755.755,0,0,0,1.08,1.055A12.494,12.494,0,1,1,4.04,34.112v-.157L5.277,35.2a.756.756,0,0,0,.534.22.767.767,0,0,0,.534-.22.754.754,0,0,0,0-1.068L3.82,31.6a.754.754,0,0,0-1.068,0L.221,34.131A.755.755,0,0,0,1.289,35.2l1.244-1.244v.157a14,14,0,1,0,27.992,0A13.911,13.911,0,0,0,26.424,24.214Z" transform="translate(0 -20.113)"/>
      <path d="M193.21,103.613a.756.756,0,0,0-.754.754v1.828h-.477a3.454,3.454,0,1,0,0,6.909h2.462a1.947,1.947,0,1,1,0,3.894h-4.428a.754.754,0,0,0,0,1.507h2.443v1.853a.754.754,0,0,0,1.507,0V118.5h.521a3.454,3.454,0,0,0-.044-6.909h-2.462a1.947,1.947,0,1,1,0-3.894h4.346a.754.754,0,1,0,0-1.507h-2.361v-1.828A.752.752,0,0,0,193.21,103.613Z" transform="translate(-176.685 -98.369)"/>
    `,
  },
  books: {
    viewBox: '0 0 24 24',
    src: svg`
      <defs><style>.a { fill: none; }</style></defs>

      <path class="a" d="M0,0H24V24H0Z"/>
      <path d="M4,6H2V20a2.006,2.006,0,0,0,2,2H18V20H4ZM20,2H8A2.006,2.006,0,0,0,6,4V16a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V4A2.006,2.006,0,0,0,20,2Zm0,14H8V4H20ZM10,9h8v2H10Zm0,3h4v2H10Zm0-6h8V8H10Z"/>
    `,
  },
  brokenLink: {
    viewBox: '0 0 52.974 52.974',
    src: svg`
      <g>
        <path d="M49.467,3.51c-4.677-4.679-12.291-4.681-16.97,0l-9.192,9.192c-0.391,0.391-0.391,1.023,0,1.414s1.023,0.391,1.414,0
          l9.192-9.192c1.88-1.88,4.391-2.915,7.07-2.915c2.681,0,5.191,1.036,7.071,2.916s2.916,4.391,2.916,7.071
          c0,2.68-1.036,5.19-2.916,7.07L36.033,31.088c-3.898,3.898-10.244,3.898-14.143,0c-0.391-0.391-1.023-0.391-1.414,0
          s-0.391,1.023,0,1.414c2.34,2.339,5.412,3.509,8.485,3.509s6.146-1.17,8.485-3.509L49.467,20.48
          c2.258-2.258,3.502-5.271,3.502-8.485C52.969,8.781,51.725,5.768,49.467,3.51z"/>
        <path d="M26.84,40.279l-7.778,7.778c-1.88,1.88-4.391,2.916-7.071,2.916c-2.68,0-5.19-1.036-7.071-2.916
          c-3.898-3.898-3.898-10.243,0-14.142l11.314-11.314c3.899-3.898,10.244-3.896,14.142,0c0.391,0.391,1.023,0.391,1.414,0
          s0.391-1.023,0-1.414c-4.677-4.679-12.291-4.681-16.97,0L3.505,32.502c-2.258,2.258-3.501,5.271-3.501,8.485
          c0,3.214,1.244,6.227,3.502,8.484s5.271,3.502,8.484,3.502c3.215,0,6.228-1.244,8.485-3.502l7.778-7.778
          c0.391-0.391,0.391-1.023,0-1.414S27.231,39.889,26.84,40.279z"/>
        <path d="M33.969,44.009c-0.553,0-1,0.447-1,1v6c0,0.553,0.447,1,1,1s1-0.447,1-1v-6C34.969,44.456,34.522,44.009,33.969,44.009z"/>
        <path d="M38.433,42.302c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l4.243,4.242c0.195,0.195,0.451,0.293,0.707,0.293
          s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L38.433,42.302z"/>
        <path d="M44.969,38.009h-6c-0.553,0-1,0.447-1,1s0.447,1,1,1h6c0.553,0,1-0.447,1-1S45.522,38.009,44.969,38.009z"/>
        <path d="M15.969,11.009c0.553,0,1-0.447,1-1v-6c0-0.553-0.447-1-1-1s-1,0.447-1,1v6C14.969,10.562,15.417,11.009,15.969,11.009z"/>
        <path d="M11.504,12.716c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L8.676,7.06
          c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L11.504,12.716z"/>
        <path d="M4.969,17.009h6c0.553,0,1-0.447,1-1s-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1S4.417,17.009,4.969,17.009z"/>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
    `,
  },
  calendar: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"/><path d="M0 0h24v24H0z" fill="none"/>`,
  },
  campaign: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M0 0h24v24H0z" fill="none"></path>
    <path d="M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"></path>`,
  },
  canceled: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>`,
  },
  cardOnFile: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M-74 29h48v48h-48V29zM0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/>
      <path d="M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"/>
    `,
  },
  charting: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <rect fill="none" height="24" width="24"/>
      </g>

      <g>
        <g>
          <path d="M20,6h-4V4c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4v2H4C2.9,6,2,6.9,2,8v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8 C22,6.9,21.1,6,20,6z M10,4h4v2h-4V4z M20,20H4V8h16V20z"/><polygon points="13,10 11,10 11,13 8,13 8,15 11,15 11,18 13,18 13,15 16,15 16,13 13,13"/>
        </g>
      </g>
    `,
  },
  changePractice: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"/>`,
  },
  checkCircle: {
    viewBox: '0 0 24 24',
    src: svg`
    <style type="text/css">
      .st0{fill:none;}
    </style>

      <path class="st0" d="M0,0h24v24H0V0z"/>
      <path d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M9.6,18l-6-6l1.7-1.7l4.3,4.3l9.1-9.1l1.7,1.7L9.6,18z"/>
    `,
  },
  checkOutline: {
    viewBox: '0 0 24 24',
    src: svg`
  <?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20">
  <defs>
    <style>
      .cls-1 {
        fill: none;
      }
      .cls-1, .cls-2 {
        stroke-width: 0px;
      }
    </style>
  </defs>
  <path class="cls-1" d="M-2-2h24v24H-2V-2Z"/>
  <path class="cls-2" d="M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10,10-4.5,10-10S15.5,0,10,0ZM10,18c-4.4,0-8-3.6-8-8S5.6,2,10,2s8,3.6,8,8-3.6,8-8,8ZM14.6,5.6l-6.6,6.6-2.6-2.6-1.4,1.4,4,4L16,7l-1.4-1.4Z"/>
</svg>
    `,
  },

  checkedIn: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <rect fill="none" height="24" width="24"/>
      </g>

      <g>
        <path d="M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z"/>
      </g>
    `,
  },
  checkedOut: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path d="M0,0h24v24H0V0z" fill="none"/>
      </g>

      <g>
        <path d="M17,8l-1.41,1.41L17.17,11H9v2h8.17l-1.58,1.58L17,16l4-4L17,8z M5,5h7V3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7v-2H5V5z"/>
      </g>
    `,
  },
  checked: {
    viewBox: '0 0 44 44',
    src: svg`<path d="m22,0c-12.2,0-22,9.8-22,22s9.8,22 22,22 22-9.8 22-22-9.8-22-22-22zm12.7,15.1l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.6-0.1-0.7-0.3l-7.8-8.4-.2-.2c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.3 0.4,0.9 0,1.3z"/>`,
  },
  checkmark: {
    viewBox: '0 0 10.9 7.494',
    src: svg`
      <path d="M1187.471,717.047l3.752,3.7,6.443-6.435" transform="translate(-1187.12 -713.961)" fill="none"/>
    `,
  },
  checkmarkOutline: {
    viewBox: '0 0 20 20',
    src: svg`
      <style type="text/css">
        .st0{fill:none;}
      </style>

      <path class="st0" d="M-2-2h24v24H-2V-2z M-2-2h24v24H-2V-2z"/>
      <path class="st1" d="M14.6,5.6L8,12.2L4.4,8.6L3,10l5,5l8-8L14.6,5.6z M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10
        S15.5,0,10,0z M10,18c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z"/>`,
  },
  chevron: {
    viewBox: '0 0 12.18 7.66',
    src: svg`
      <path d="M1.5.12,6.09,4.7,10.68.12l1.41,1.41-6,6-6-6Z"/>
    `,
  },
  chevronBold: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
    `,
  },
  chevronRotatedLeft: {
    viewBox: '0 0 12.18 7.66',
    src: svg`
      <g transform="rotate(90 6.09 3.83)">
        <path d="M1.5.12,6.09,4.7,10.68.12l1.41,1.41-6,6-6-6Z"/>
      </g>
    `,
  },
  chevronRotatedRight: {
    viewBox: '0 0 12.18 7.66',
    src: svg`
      <g transform="rotate(-90 6.09 3.83)">
        <path d="M1.5.12,6.09,4.7,10.68.12l1.41,1.41-6,6-6-6Z"/>
      </g>
    `,
  },
  chevronDouble: {
    viewBox: '0 0 58 56',
    src: svg`
      <path d="M25.63,28.3.56,53.39a1.89,1.89,0,0,0,2.66,2.66L29.63,29.63a1.88,1.88,0,0,0,0-2.66h0L3.22.55A1.89,1.89,0,0,0,.55,3.22h0Z"/>
      <path d="M53.65,28.3,28.58,53.39a1.89,1.89,0,0,0,.2,2.66,1.91,1.91,0,0,0,2.46,0L57.65,29.63a1.89,1.89,0,0,0,0-2.66h0L31.24.55a1.89,1.89,0,0,0-2.67,2.67h0Z"/>
    `,
  },
  chevronRight: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/><path fill="none" d="M0 0h24v24H0V0z"/>
    `,
  },
  clear: {
    viewBox: '0 0 52 52',
    src: svg`
      <path
        d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26
        S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"/>
      <path
        d="M35.707,16.293c-0.391-0.391-1.023-0.391-1.414,0L26,24.586l-8.293-8.293c-0.391-0.391-1.023-0.391-1.414,0
        s-0.391,1.023,0,1.414L24.586,26l-8.293,8.293c-0.391,0.391-0.391,1.023,0,1.414C16.488,35.902,16.744,36,17,36
        s0.512-0.098,0.707-0.293L26,27.414l8.293,8.293C34.488,35.902,34.744,36,35,36s0.512-0.098,0.707-0.293
        c0.391-0.391,0.391-1.023,0-1.414L27.414,26l8.293-8.293C36.098,17.316,36.098,16.684,35.707,16.293z"/>
    `,
  },
  clock: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>`,
  },
  close: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    `,
  },
  codeBundle: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/>
      <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"/>
    `,
  },
  colorPicker: {
    viewBox: '0 0 54 54',
    src: svg`
      <path d="M50.74,28.27a2.86,2.86,0,0,0-.84-2L30.58,6.92h0l0,0-3-3a2.85,2.85,0,0,0-1.6-.8c-4.42-3-8.18-3.66-10.1-1.74-1.76,1.76-1.32,5.11,1.09,9.07L2.11,25.22a7.19,7.19,0,0,0,0,10.17L18.38,51.66a7.2,7.2,0,0,0,10.17,0L49.9,30.3a2.86,2.86,0,0,0,.84-2ZM17.87,3.36c.47-.48,2.3-.32,4.94,1.16L19,8.3c-1.5-2.67-1.64-4.47-1.16-4.95Zm8.64,46.27a4.32,4.32,0,0,1-6.1,0L4.14,33.35a4.31,4.31,0,0,1,0-6.1L18.57,12.82a32.63,32.63,0,0,0,2.85,3.25,31.94,31.94,0,0,0,3.89,3.33,4.32,4.32,0,1,0,1.43-2.51A29.45,29.45,0,0,1,23.46,14a29.74,29.74,0,0,1-2.83-3.27l4.63-4.63a28.85,28.85,0,0,1,3.28,2.82L47.86,28.27Zm1.61-29.49a1.44,1.44,0,1,1,.42,1,1.43,1.43,0,0,1-.42-1Zm0,0"/><path d="M49.29,36.49a1.44,1.44,0,0,0-1.25.73c-.58,1-3.46,6.24-3.46,9a4.71,4.71,0,0,0,9.42,0c0-2.72-2.88-7.94-3.46-9a1.44,1.44,0,0,0-1.25-.73Zm0,11.52a1.84,1.84,0,0,1-1.83-1.83A16.85,16.85,0,0,1,49.29,41a16.84,16.84,0,0,1,1.83,5.14A1.84,1.84,0,0,1,49.29,48Zm0,0"/>
    `,
  },
  confirmed: {
    viewBox: '0 0 24 24',
    src: svg`
    <g>
      <path d="M16.5,22.5L13,19l1.4-1.4l2.1,2.1l4.2-4.2l1.4,1.4L16.5,22.5z"/>
    </g>

    <g>
      <path d="M11.2,20H5V10h14v4.4l2-2V6c0-1.1-0.9-2-2-2h-1V2h-2v2H8V2H6v2H5C3.9,4,3,4.9,3,6l0,14c0,1.1,0.9,2,2,2h8.2L11.2,20z"/>
    </g>
  `,
  },
  copy: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
    `,
  },
  creditCard: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
    `,
  },
  dashboard: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    `,
  },
  day: {
    viewBox: '0 0 59 59',
    src: svg`
      <rect class="cls-1" x="1.61" y="2.38" width="24.42" height="24.42" rx="3.48" ry="3.48"/>
      <rect class="cls-1" x="32.34" y="2.38" width="24.42" height="24.42" rx="3.48" ry="3.48"/>
      <rect class="cls-1" x="1.61" y="31.57" width="24.42" height="24.42" rx="3.48" ry="3.48"/>
      <rect class="cls-1" x="32.34" y="31.57" width="24.42" height="24.42" rx="3.48" ry="3.48"/>
    `,
  },
  delete: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
    `,
  },
  discount: {
    viewBox: '0 0 24 24',
    src: svg`
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#0caadc">
      <path d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Z"/>
    `,
  },

  dismissResponse: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"/>`,
  },
  download: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
    `,
  },
  edit: {
    viewBox: '0 0 18 18',
    src: svg`
      <style type="text/css">
        .st1{fill:none;}
      </style>

      <path class="st0" d="M0,14.3V18h3.8L14.8,6.9l-3.7-3.7L0,14.3z M17.7,4c0.4-0.4,0.4-1,0-1.4l-2.3-2.3c-0.4-0.4-1-0.4-1.4,0l-1.8,1.8
        l3.8,3.8C15.9,5.9,17.7,4,17.7,4z"/>
      <path class="st1" d="M-3-3h24v24H-3V-3z"/>
    `,
  },
  editNote: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M10.2,22.5L3,15.4v-12C3,2.1,4.1,1,5.4,1h13.2c1.3,0,2.4,1.1,2.4,2.4l0,16.7c0,1.3-1.1,2.4-2.4,2.4H10.2z M11.4,14.2H4.8
    l6.6,6.6V14.2z"/>`,
  },
  electronic: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M8.46,14.45L7.1,13.83 c0.28-0.61,0.41-1.24,0.4-1.86c-0.01-0.63-0.14-1.24-0.4-1.8l1.36-0.63c0.35,0.75,0.53,1.56,0.54,2.4 C9.01,12.8,8.83,13.64,8.46,14.45z M11.53,16.01l-1.3-0.74c0.52-0.92,0.78-1.98,0.78-3.15c0-1.19-0.27-2.33-0.8-3.4l1.34-0.67 c0.64,1.28,0.96,2.65,0.96,4.07C12.51,13.55,12.18,14.86,11.53,16.01z M14.67,17.33l-1.35-0.66c0.78-1.6,1.18-3.18,1.18-4.69 c0-1.51-0.4-3.07-1.18-4.64l1.34-0.67C15.56,8.45,16,10.23,16,11.98C16,13.72,15.56,15.52,14.67,17.33z"/>
    `,
  },
  electronicClaims: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"/>`,
  },
  eligibilityReport: {
    viewBox: '0 0 24 24',
    src: svg`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#5f6368"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M20,3H4C2.9,3,2,3.9,2,5v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V5 C22,3.9,21.1,3,20,3z M10,17H5v-2h5V17z M10,13H5v-2h5V13z M10,9H5V7h5V9z M14.82,15L12,12.16l1.41-1.41l1.41,1.42L17.99,9 l1.42,1.42L14.82,15z" fill-rule="evenodd"/></g></g></svg>
  `,
  },
  ellipsis: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
    `,
  },
  email: {
    viewBox: '0 0 20 15.333',
    src: svg`
      <style type="text/css">
        .st0{fill:none;}
      </style>

      <path class="st0" d="M0,0h20v15.3H0V0z"/>
      <path  d="M19,59.733H1a1,1,0,0,0-1,1V74.066a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V60.733A1,1,0,0,0,19,59.733Zm.333,14.333A.333.333,0,0,1,19,74.4H1a.333.333,0,0,1-.333-.333V60.733A.333.333,0,0,1,1,60.4H19a.333.333,0,0,1,.333.333V74.066Z" transform="translate(0 -59.733)"/>
      <path  d="M51.166,93.866a.334.334,0,0,0-.243.077l-7.692,6.45a.668.668,0,0,1-.858,0l-7.692-6.45a.333.333,0,1,0-.429.51l7.692,6.449a1.334,1.334,0,0,0,1.716,0l7.692-6.449a.333.333,0,0,0-.185-.587Z" transform="translate(-32.802 -92.534)"/>
      <path  d="M39.075,272.933a.333.333,0,0,0-.321.1l-4.659,4.992a.333.333,0,1,0,.487.454l4.659-4.992a.333.333,0,0,0-.166-.557Z" transform="translate(-32.674 -264.586)"/>
      <path  d="M341.782,273.036a.333.333,0,1,0-.487.454l4.659,4.992a.333.333,0,0,0,.487-.454Z" transform="translate(-327.862 -264.586)"/>
    `,
  },
  emailFilled: {
    viewBox: '0 0 24 24',
    src: svg`
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#0caadc">
        <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280 320-200v-80L480-520 160-720v80l320 200Z"></path>
      </svg>
    `,
  },
  engage: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
    `,
  },
  error: {
    viewBox: '0 0 24 24',
    src: svg`
    <style type="text/css">
      .st0{fill:none;}
    </style>

    <path class="st0" d="M0,0h24v24H0V0z"/>
    <path d="M17,0H7L0,7V17l7,7H17l7-7V7L17,0z M18.7,17L17,18.7l-5-5l-5,5L5.3,17l5-5l-5-5L7,5.3l5,5l5-5L18.7,7l-5,5L18.7,17z"/>
    `,
  },
  expand: {
    viewBox: '0 0 60 60',
    src: svg`
      <path
        d="M18,26c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S20.206,26,18,26z M18,32c-1.103,0-2-0.897-2-2s0.897-2,2-2
        s2,0.897,2,2S19.103,32,18,32z"/>
      <path
        d="M30,26c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S32.206,26,30,26z M30,32c-1.103,0-2-0.897-2-2s0.897-2,2-2
        s2,0.897,2,2S31.103,32,30,32z"/>
      <path
        d="M46,30c0-2.206-1.794-4-4-4s-4,1.794-4,4s1.794,4,4,4S46,32.206,46,30z M42,32c-1.103,0-2-0.897-2-2s0.897-2,2-2
        s2,0.897,2,2S43.103,32,42,32z"/>
      <path
        d="M2.414,30l13.293-13.293c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-14,14c-0.391,0.391-0.391,1.023,0,1.414
        l14,14C14.488,44.902,14.744,45,15,45s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L2.414,30z"/>
      <path
        d="M59.707,29.293l-14-14c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L57.586,30L44.293,43.293
        c-0.391,0.391-0.391,1.023,0,1.414C44.488,44.902,44.744,45,45,45s0.512-0.098,0.707-0.293l14-14
        C60.098,30.316,60.098,29.684,59.707,29.293z"/>
    `,
  },
  fee: {
    viewBox: '0 0 30 26.66',
    src: svg`
    <g id="purse" transform="translate(0 -28.499)">
      <g id="Group_1396" data-name="Group 1396" transform="translate(0 28.499)">
        <g id="Group_1395" data-name="Group 1395" transform="translate(0 0)">
          <path id="Path_412" data-name="Path 412" d="M28.682,39.632h-.439V33.626a2.786,2.786,0,0,0-2.783-2.783H13.39L5.248,28.516l-.007,0-.007,0-.015,0-.023,0-.02,0-.024,0H5.09l-.025,0-.017,0-.025.005-.015,0-.025.008-.014.005-.025.011-.013.006-.024.013-.012.008-.023.015-.012.009-.021.017-.011.01-.019.019L4.8,28.65l-.016.02-.011.015-.013.02-.01.018-.011.02-.009.02-.008.02-.007.022,0,.014,0,.007,0,.007-.5,2.01H2.783A2.786,2.786,0,0,0,0,33.616s0,.006,0,.009V48.86a.439.439,0,0,0,.879,0V35.653a2.772,2.772,0,0,0,1.9.756H25.461a1.906,1.906,0,0,1,1.9,1.9V41.39H22.528l-.038,0-.041.006h-.006l-.034.008-.007,0-.029.01-.011,0-.024.011-.015.007-.018.01-.019.012-.012.009-.022.017-.009.008-.023.021-.012.013-.017.019q-.014.017-.026.034h0L19.82,45.1a.432.432,0,0,0-.041.077c0,.01-.007.02-.011.031l0,.009c0,.011-.006.022-.008.033l0,.009c0,.01,0,.02,0,.03s0,.008,0,.013,0,.016,0,.024,0,.012,0,.019,0,.012,0,.018,0,.017,0,.025,0,.008,0,.012,0,.02,0,.03l0,.008c0,.011,0,.022.008.033l0,.009c0,.01.007.02.011.031a.438.438,0,0,0,.041.078L22.164,49.1h0a.455.455,0,0,0,.031.04l.011.012.023.024.014.013.026.021.012.009a.439.439,0,0,0,.041.025l.011.005.035.015.014.005.034.011.014,0,.036.007.013,0,.046,0h4.838v3.077a1.907,1.907,0,0,1-1.9,1.9H2.784a1.907,1.907,0,0,1-1.9-1.9s0,0,0-.007V50.618a.439.439,0,1,0-.879,0v1.758s0,.009,0,.014a2.786,2.786,0,0,0,2.783,2.77H25.459a2.786,2.786,0,0,0,2.783-2.783h0V49.3h.439A1.32,1.32,0,0,0,30,47.982V40.95A1.32,1.32,0,0,0,28.682,39.632ZM5.443,29.486,13.2,31.7h0l5.2,1.485H4.518Zm21.92,6.8a2.772,2.772,0,0,0-1.9-.756H2.783a1.9,1.9,0,0,1,0-3.809h1.2l-.366,1.465H2.784a.439.439,0,1,0,0,.879H24.873a.439.439,0,1,0,0-.879H21.595l-5.129-1.465h8.993a1.907,1.907,0,0,1,1.9,1.9Zm1.757,11.7h0a.44.44,0,0,1-.439.439H22.764l-2.051-3.076,2.051-3.076H28.7a1.313,1.313,0,0,0,.421-.075v5.789Zm-.439-6.592h-.439v-.879h.439a.439.439,0,1,1,0,.878Z" transform="translate(0 -28.499)"/>
        </g>
      </g>
      <g id="Group_1398" data-name="Group 1398" transform="translate(22.676 43.733)">
        <g id="Group_1397" data-name="Group 1397" transform="translate(0 0)">
          <path id="Path_413" data-name="Path 413" d="M388.61,288.493a1.611,1.611,0,1,0,1.611,1.611A1.613,1.613,0,0,0,388.61,288.493Zm0,2.344a.732.732,0,1,1,.732-.732A.733.733,0,0,1,388.61,290.837Z" transform="translate(-386.999 -288.493)" fill="#0b9fcb"/>
        </g>
      </g>
    </g>`,
  },
  folder: {
    viewBox: '0 0 24 24',
    src: svg`
      <defs><style>.a { fill: none; }</style></defs>

      <path d="M10,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V8a2.006,2.006,0,0,0-2-2H12Z"/>
      <path class="a" d="M0,0H24V24H0Z"/>
    `,
  },
  folderLine: {
    viewBox: '0 0 60 60',
    src: svg`<path
      d="M26.525,10.5l-4.618-6.451L21.515,3.5H0v53h60v-46H26.525z M58,12.5v5H31.536l-3.579-5H58z M2,54.5v-49h18.485l5,7h0.012
      l4.69,6.551c0.195,0.272,0.501,0.417,0.813,0.418V19.5h27v35H2z"
    />
    `,
  },
  fullscreen: {
    viewBox: '0 0 492.308 492.308',
    src: svg`
      <path d="M0,0v492.308h492.308V0H0z M472.615,472.615H19.692V19.692h452.923V472.615z"/>
      <polygon points="263.125,68.923 263.125,88.615 389.769,88.615 235.909,242.476 249.832,256.399 403.692,102.538 403.692,229.183
        423.385,229.183 423.385,68.923"/>
    `,
  },
  help: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>
    `,
  },
  hourglassTop: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <rect fill="none" height="24" width="24"/>
      </g>

      <g>
        <path d="M6,2l0.01,6L10,12l-3.99,4.01L6,22h12v-6l-4-4l4-3.99V2H6z M16,16.5V20H8v-3.5l4-4L16,16.5z"/>
      </g>
    `,
  },
  info: {
    viewBox: '0 0 24 24',
    src: svg`
      <path  d="M11.812,0C5.289,0,0,5.289,0,11.812s5.289,11.813,11.812,11.813s11.813-5.29,11.813-11.813
        S18.335,0,11.812,0z M14.271,18.307c-0.608,0.24-1.092,0.422-1.455,0.548c-0.362,0.126-0.783,0.189-1.262,0.189
        c-0.736,0-1.309-0.18-1.717-0.539s-0.611-0.814-0.611-1.367c0-0.215,0.015-0.435,0.045-0.659c0.031-0.224,0.08-0.476,0.147-0.759
        l0.761-2.688c0.067-0.258,0.125-0.503,0.171-0.731c0.046-0.23,0.068-0.441,0.068-0.633c0-0.342-0.071-0.582-0.212-0.717
        c-0.143-0.135-0.412-0.201-0.813-0.201c-0.196,0-0.398,0.029-0.605,0.09c-0.205,0.063-0.383,0.12-0.529,0.176l0.201-0.828
        c0.498-0.203,0.975-0.377,1.43-0.521c0.455-0.146,0.885-0.218,1.29-0.218c0.731,0,1.295,0.178,1.692,0.53
        c0.395,0.353,0.594,0.812,0.594,1.376c0,0.117-0.014,0.323-0.041,0.617c-0.027,0.295-0.078,0.564-0.152,0.811l-0.757,2.68
        c-0.062,0.215-0.117,0.461-0.167,0.736c-0.049,0.275-0.073,0.485-0.073,0.626c0,0.356,0.079,0.599,0.239,0.728
        c0.158,0.129,0.435,0.194,0.827,0.194c0.185,0,0.392-0.033,0.626-0.097c0.232-0.064,0.4-0.121,0.506-0.17L14.271,18.307z
        M14.137,7.429c-0.353,0.328-0.778,0.492-1.275,0.492c-0.496,0-0.924-0.164-1.28-0.492c-0.354-0.328-0.533-0.727-0.533-1.193
        c0-0.465,0.18-0.865,0.533-1.196c0.356-0.332,0.784-0.497,1.28-0.497c0.497,0,0.923,0.165,1.275,0.497
        c0.353,0.331,0.53,0.731,0.53,1.196C14.667,6.703,14.49,7.101,14.137,7.429z"/>
    </g>
    `,
  },
  infoMinimal: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0,0h24v24H0V0z" fill="none"/>
    <path d="M11,7h2v2h-2V7z M11,11h2v6h-2V11z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20 c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"/>
    `,
  },
  informs: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>
    `,
  },
  insights: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M6,16.5L3,19.44V11H6M11,14.66L9.43,13.32L8,14.64V7H11M16,13L13,16V3H16M18.81,12.81L17,11H22V16L20.21,14.21L13,21.36L9.53,18.34L5.75,22H3L9.47,15.66L13,18.64" />
    `,
  },
  insurance: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0 0h24v24H0V0z" fill="none"/><path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"/>
    `,
  },
  key: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
      <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
    `,
  },
  keyboard: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"/>
      <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
    `,
  },
  location: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/><path d="M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"/>
    `,
  },
  lock: {
    viewBox: '0 0 24 24',
    src: svg`
      <g fill="none">
        <path d="M0 0h24v24H0V0z"/>
        <path d="M0 0h24v24H0V0z" opacity=".87"/>
      </g>

      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
    `,
  },
  logo: {
    viewBox: '0 0 531.041 71.33',
    src: svg`
      <g id="Group_245" data-name="Group 245" transform="translate(-53.861 -140.787)">
        <path id="Path_1" data-name="Path 1" d="M102.743,194.734l-2.267,10.538H70.159q-19.128,0-15.807-15.406l4.3-20.259q3.244-15.4,22.371-15.406h30.317l-2.187,10.538H78.832q-8.991,0-10.046,4.867l-4.3,20.259q-1.049,4.873,7.948,4.867Z" transform="translate(0 6.845)" fill="#fff" fill-rule="evenodd"/>
        <path id="Path_2" data-name="Path 2" d="M150.235,212.117H140.1l7.625-35.665c.7-3.236-1.942-4.867-7.948-4.867H108.33l-8.673,40.532H89.52l15.236-71.33h10.136l-4.375,20.259h31.444q19.128,0,15.884,15.406Z" transform="translate(18.194 0)" fill="#fff" fill-rule="evenodd"/>
        <path id="Path_3" data-name="Path 3" d="M148.282,140.787h13.542l-2.836,13.127h-13.54Zm-2.588,20.259H155.83l-10.861,51.071H134.832Z" transform="translate(41.312 0)" fill="#fff" fill-rule="evenodd"/>
        <path id="Path_4" data-name="Path 4" d="M157.835,205.273H147.7l7.625-35.665q3.244-15.4,22.371-15.406h7.858l-2.188,10.538h-7.858q-8.991,0-10.046,4.867Z" transform="translate(47.876 6.845)" fill="#fff" fill-rule="evenodd"/>
        <path id="Path_5" data-name="Path 5" d="M210.941,194.734q8.991,0,9.967-4.7l4.377-20.427c.7-3.236-1.942-4.867-7.95-4.867H194.889q-8.991,0-10.046,4.867l-4.3,20.259q-1.049,4.873,7.948,4.867Zm-36.234-25.127q3.242-15.4,22.369-15.406h22.448q19.128,0,15.884,15.406l-4.375,20.427q-3.244,15.243-22.371,15.238H186.215q-19.126,0-15.806-15.406Z" transform="translate(59.213 6.845)" fill="#fff" fill-rule="evenodd"/>
        <path id="Path_6" data-name="Path 6" d="M221.269,161.046h5.592l4.376-20.26h9.243l-4.388,20.26H248.17l-2.188,10.538H233.9l-8.673,40.532H216l8.674-40.532h-5.605Z" transform="translate(82.724)" fill="#0b9fcb" fill-rule="evenodd"/>
        <path id="Path_7" data-name="Path 7" d="M275.891,194.734q8.991,0,9.969-4.7l4.375-20.427c.7-3.236-1.942-4.867-7.948-4.867H259.839q-8.991,0-10.046,4.867l-4.3,20.259q-1.049,4.873,7.948,4.867Zm-36.234-25.127q3.244-15.4,22.369-15.406h22.448q19.128,0,15.884,15.406l-4.375,20.427q-3.244,15.243-22.371,15.238H251.166q-19.128,0-15.807-15.406Z" transform="translate(92.35 6.845)" fill="#0b9fcb" fill-rule="evenodd"/>
        <path id="Path_8" data-name="Path 8" d="M320.016,194.734q8.991,0,9.967-4.7l7.625-35.833h10.137l-7.625,35.833q-3.242,15.243-22.369,15.238H295.3q-19.128,0-15.807-15.406L287.03,154.2h10.137l-7.534,35.665c-.7,3.248,1.942,4.867,7.95,4.867Z" transform="translate(114.869 6.845)" fill="#0b9fcb" fill-rule="evenodd"/>
        <path id="Path_9" data-name="Path 9" d="M373.164,194.734,370.9,205.273H340.58q-19.126,0-15.806-15.406l4.3-20.259q3.242-15.4,22.369-15.406H381.76l-2.188,10.538H349.254q-8.991,0-10.046,4.867l-4.3,20.259q-1.049,4.873,7.948,4.867Z" transform="translate(137.97 6.845)" fill="#0b9fcb" fill-rule="evenodd"/>
        <path id="Path_10" data-name="Path 10" d="M420.657,212.117H410.52l7.625-35.665c.7-3.236-1.942-4.867-7.95-4.867H378.752l-8.673,40.532H359.942l15.236-71.33h10.137l-4.375,20.259h31.444q19.126,0,15.884,15.406Z" transform="translate(156.164 0)" fill="#0b9fcb" fill-rule="evenodd"/>
      </g>
    `,
  },
  logoAmex: {
    viewBox: '0 0 154.21 81.6',
    src: svg`
      <defs>
        <style>
          .cls-1 {
            fill: #306fb7;
          }

          .cls-1, .cls-2 {
            stroke-width: 0px;
          }

          .cls-2 {
            fill: #fff;
          }
        </style>
      </defs>
      <path id="path3076" class="cls-2" d="M94.42,29.18s-.11-.12-.16-.25c-.08-.18-.17-.51-.17-1.06,0-.79.24-1.17.39-1.31.11-.11.28-.21.59-.21h2.75l-1.34,3.12h-.87c-.79,0-1.1-.2-1.19-.29ZM18.42,17.84l-8.55,19.88h9.65l1.18-2.98h3.48l1.18,2.98c19.76,0,28.24,0,48.07,0v-2.82l2.38,2.82h11.28,0s1.43,0,1.43,0v-2.07c.57.51,1.22.93,1.93,1.27.79.37,1.64.61,2.53.73l-.03.08h9.65l1.18-2.98h3.48l1.18,2.98h9.74,0s2.87,0,2.87,0v-3.63l2.34,3.63h8.43v-19.88h-8.71v3.39l-2.19-3.39h-8.58v6.28l-2.7-6.27c-.66,0-15.32,0-14.4,0-1.66,0-3.18.28-4.53.88-.81.36-1.54.81-2.18,1.37v-2.25c-12.44,0-28.72,0-45.79,0l-1.62,4.65-1.66-4.62-10.17-.04v6.3l-2.7-6.29h-8.14ZM38.27,43.89v19.88h20.98l2.19-2.94,2.24,2.94c1.3,0-4.7,0,12.68,0v-4.7c.81-.06,3.72.36,6.37-1.3v6h8.71v-2.82l2.38,2.82c1.48,0,44.19,0,41.92,0,4.5,0,7.35-3.09,7.35-7.23,0-2-.7-3.88-2.24-5.17l3.5-7.47c-.72,0-84.06,0-80.41,0l-2.39,3.08-2.39-3.08h-20.88Z"/>
      <g>
        <path id="path3046" class="cls-1" d="M20.06,20.33l-6.4,14.89h4.17l1.18-2.98h6.87l1.18,2.98h4.26l-6.4-14.89h-4.85ZM22.43,23.8l2.09,5.21h-4.19l2.1-5.21Z"/>
        <path id="path3048" class="cls-1" d="M31.75,35.22v-14.89l5.92.02,3.45,9.6,3.36-9.62h5.88v14.89h-3.72v-10.97l-3.95,10.97h-3.26l-3.96-10.97v10.97h-3.72Z"/>
        <path id="path3050" class="cls-1" d="M52.91,35.22v-14.89h12.15v3.33h-8.38v2.55h8.19v3.13h-8.19v2.64h8.38v3.23h-12.15Z"/>
        <path id="path3052" class="cls-1" d="M67.21,20.33v14.89h3.72v-5.29h1.57l4.46,5.29h4.55l-4.9-5.49c2.01-.17,4.08-1.89,4.08-4.57,0-3.13-2.46-4.83-5.2-4.83h-8.28ZM70.93,23.66h4.25c1.02,0,1.76.8,1.76,1.57,0,.99-.96,1.57-1.71,1.57h-4.31v-3.13h0Z"/>
        <path id="path3054" class="cls-1" d="M86.02,35.22h-3.8v-14.89h3.8v14.89Z"/>
        <path id="path3056" class="cls-1" d="M95.03,35.22h-.82c-3.97,0-6.38-3.13-6.38-7.38s2.38-7.51,7.4-7.51h4.11v3.53h-4.26c-2.03,0-3.47,1.59-3.47,4.02,0,2.88,1.65,4.09,4.02,4.09h.98l-1.57,3.25Z"/>
        <path id="path3058" class="cls-1" d="M103.13,20.33l-6.4,14.89h4.17l1.18-2.98h6.87l1.18,2.98h4.26l-6.4-14.89h-4.85ZM105.5,23.8l2.09,5.21h-4.19l2.1-5.21h0Z"/>
        <path id="path3060" class="cls-1" d="M114.81,35.22v-14.89h4.73l6.04,9.35v-9.35h3.72v14.89h-4.58l-6.2-9.6v9.6h-3.72Z"/>
        <path id="path3062" class="cls-1" d="M40.76,61.27v-14.89h12.15v3.33h-8.38v2.55h8.19v3.13h-8.19v2.64h8.38v3.23h-12.15Z"/>
        <path id="path3064" class="cls-1" d="M100.28,61.27v-14.89h12.15v3.33h-8.38v2.55h8.15v3.13h-8.15v2.64h8.38v3.23h-12.15Z"/>
        <path id="path3066" class="cls-1" d="M53.38,61.27l5.91-7.35-6.05-7.54h4.69l3.61,4.66,3.62-4.66h4.51l-5.98,7.44,5.92,7.44h-4.69l-3.5-4.59-3.42,4.59h-4.62Z"/>
        <path id="path3068" class="cls-1" d="M70.05,46.39v14.89h3.82v-4.7h3.92c3.32,0,5.83-1.76,5.83-5.18,0-2.83-1.97-5.01-5.34-5.01h-8.22ZM73.87,49.76h4.13c1.07,0,1.84.66,1.84,1.71,0,.99-.76,1.71-1.85,1.71h-4.11v-3.43h0Z"/>
        <path id="path3072" class="cls-1" d="M85.23,46.39v14.89h3.72v-5.29h1.57l4.46,5.29h4.55l-4.9-5.49c2.01-.17,4.08-1.89,4.08-4.57,0-3.13-2.46-4.83-5.2-4.83h-8.28ZM88.95,49.72h4.25c1.02,0,1.76.8,1.76,1.57,0,.99-.96,1.57-1.71,1.57h-4.31v-3.13Z"/>
        <path id="path3074" class="cls-1" d="M114.15,61.27v-3.23h7.45c1.1,0,1.58-.6,1.58-1.25s-.48-1.26-1.58-1.26h-3.37c-2.93,0-4.56-1.78-4.56-4.46,0-2.39,1.49-4.69,5.84-4.69h7.25l-1.57,3.35h-6.27c-1.2,0-1.57.63-1.57,1.23s.46,1.3,1.37,1.3h3.53c3.26,0,4.68,1.85,4.68,4.27,0,2.6-1.58,4.74-4.85,4.74h-7.93Z"/>
        <path class="cls-1" d="M127.81,61.27v-3.23h7.45c1.1,0,1.58-.6,1.58-1.25s-.48-1.26-1.58-1.26h-3.37c-2.93,0-4.56-1.78-4.56-4.46,0-2.39,1.49-4.69,5.84-4.69h7.25l-1.57,3.35h-6.27c-1.2,0-1.57.63-1.57,1.23s.46,1.3,1.37,1.3h3.53c3.26,0,4.68,1.85,4.68,4.27,0,2.6-1.58,4.74-4.85,4.74h-7.93Z"/>
      </g>
    `,
  },
  logoDiscovery: {
    viewBox: '0 0 154.21 81.6',
    src: svg`
      <defs>
        <style>
          .cls-1 {
            fill: #fff;
          }

          .cls-1, .cls-2 {
            stroke-width: 0px;
          }

          .cls-2 {
            fill: #f3722c;
          }
        </style>
      </defs>
      <g>
        <path class="cls-1" d="M14.34,29.8h-6.25v21.84h6.22c7.36,0,11.76-5.15,11.76-10.91,0-6.45-4.82-10.94-11.73-10.94ZM19.32,46.21c-2.39,2.16-6.15,1.66-6.97,1.74v-14.44c1.69.15,4.56-.42,6.97,1.77,3.21,2.86,3.07,8.21,0,10.94Z"/>
        <rect class="cls-1" x="28.03" y="29.8" width="4.26" height="21.84"/>
        <path class="cls-1" d="M39.4,35.43c0-2.28,3.83-3.76,6.61-.65l2.23-2.92c-5.23-4.57-13.23-2.32-13.23,3.84,0,7.26,9.6,4.94,9.6,9.49,0,3.72-5.75,4.44-7.96.17l-2.75,2.65c1.96,2.88,4.32,4.16,7.56,4.16,4.43,0,7.53-2.94,7.53-7.17,0-7.55-9.59-5.9-9.59-9.56Z"/>
        <path class="cls-1" d="M50.33,40.74c0,8.33,8.52,14.06,16.87,10.13v-5.02c-4.96,4.96-12.48,1.73-12.48-5.14,0-6.29,7.06-10.34,12.48-5.04v-5.01c-8.09-4.1-16.87,1.83-16.87,10.09Z"/>
        <polygon class="cls-1" points="100.99 44.47 95.16 29.8 90.51 29.8 99.78 52.2 102.07 52.2 111.51 29.8 106.89 29.8 100.99 44.47"/>
        <polygon class="cls-1" points="113.43 51.64 125.52 51.64 125.52 47.95 117.69 47.95 117.69 42.05 125.23 42.05 125.23 38.35 117.69 38.35 117.69 33.5 125.52 33.5 125.52 29.8 113.43 29.8 113.43 51.64"/>
        <path class="cls-1" d="M142.39,36.25c0-4.09-2.82-6.45-7.73-6.45h-6.32v21.84h4.26v-8.78h.56l5.9,8.78h5.24l-6.88-9.2c3.21-.65,4.98-2.85,4.98-6.19ZM132.6,39.86v-6.62c.66.14,5.41-.92,5.41,3.24s-4.83,3.25-5.41,3.38Z"/>
        <g>
          <path class="cls-1" d="M145.11,30.62c0-.38-.26-.59-.73-.59h-.62v1.92h.46v-.74l.54.74h.56l-.63-.79c.27-.07.42-.27.42-.54ZM144.3,30.88h-.08v-.5h.08c.23,0,.34.08.34.25s-.12.26-.35.26Z"/>
          <path class="cls-1" d="M144.47,29.31c-.93,0-1.67.74-1.67,1.67s.75,1.67,1.67,1.67,1.65-.75,1.65-1.67-.74-1.67-1.65-1.67ZM144.47,32.36c-.73,0-1.33-.61-1.33-1.37s.59-1.37,1.33-1.37,1.33.62,1.33,1.37-.6,1.37-1.33,1.37Z"/>
        </g>
      </g>
      <rect class="cls-2" x="68.7" y="29.23" width="23.15" height="23.15" rx="11.58" ry="11.58"/>
    `,
  },
  logoMark: {
    viewBox: '0 0 48.251 24.753',
    src: svg`
      <g id="ChiroTouch_CT" transform="translate(-134.166 -66.58)">
        <path id="Path_989" data-name="Path 989" d="M154.247,87.491l-.759,3.527H140.123q-6.405,0-5.292-5.154l2.922-13.356q1.086-5.154,7.49-5.157h13.365l-.734,3.527H144.509q-3.015,0-3.364,1.627L138.223,85.86q-.353,1.627,2.659,1.627h13.366Z" transform="translate(0 -0.185)" fill="#fff" stroke="#fff" stroke-width="1" fill-rule="evenodd"/>
        <path id="Path_990" data-name="Path 990" d="M218.739,67.08H239.03l-.705,3.4h-8.591l-4.345,20.348H221.98l4.345-20.348h-8.3Z" transform="translate(-57.227)" fill="#0b9fcb" stroke="#0b9fcb" stroke-width="1" fill-rule="evenodd"/>
      </g>
    `,
  },
  logoMasterCard: {
    viewBox: '0 0 154.21 81.6',
    src: svg`
      <defs>
        <style>
          .cls-1 {
            fill: #f69e1e;
          }

          .cls-1, .cls-2, .cls-3, .cls-4 {
            stroke-width: 0px;
          }

          .cls-2 {
            fill: #f26122;
          }

          .cls-3 {
            fill: #ea1d25;
          }

          .cls-4 {
            fill: #fff;
          }
        </style>
      </defs>
      <g>
        <circle class="cls-1" cx="92.25" cy="34.25" r="24.51" transform="translate(-6.08 37.91) rotate(-22.5)"/>
        <circle class="cls-3" cx="61.96" cy="34.25" r="24.51" transform="translate(-8.39 26.32) rotate(-22.5)"/>
        <path class="cls-2" d="M67.75,34.25c0,7.82,3.66,14.77,9.36,19.26,5.7-4.49,9.36-11.44,9.36-19.26s-3.66-14.77-9.36-19.26c-5.7,4.49-9.36,11.44-9.36,19.26Z"/>
      </g>
      <path class="cls-4"
        d="M51.72,71.52v-4.07c.09-1.33-.91-2.48-2.24-2.57-.1,0-.21,0-.31,0-.91-.06-1.79.38-2.28,1.15-.45-.75-1.27-1.19-2.14-1.15-.76-.04-1.48.33-1.9.96v-.8h-1.41v6.48h1.42v-3.57c-.11-.83.47-1.6,1.3-1.71.1-.01.19-.02.29-.01.94,0,1.41.61,1.41,1.71v3.61h1.42v-3.59c-.11-.84.48-1.6,1.31-1.71.09-.01.18-.02.27-.01.96,0,1.42.61,1.42,1.71v3.61l1.42-.03ZM72.79,65.04h-2.32v-1.97h-1.42v1.97h-1.29v1.29h1.32v2.98c0,1.5.58,2.4,2.25,2.4.62,0,1.23-.17,1.76-.5l-.41-1.21c-.38.23-.81.35-1.25.37-.68,0-.94-.43-.94-1.08v-2.96h2.3v-1.29ZM84.81,64.88c-.7-.02-1.36.34-1.71.95v-.79h-1.4v6.48h1.41v-3.63c0-1.07.46-1.67,1.36-1.67.3,0,.6.05.88.16l.43-1.36c-.32-.12-.66-.17-1-.18l.03.03ZM66.63,65.56c-.8-.47-1.72-.71-2.64-.68-1.64,0-2.71.79-2.71,2.07,0,1.06.79,1.71,2.24,1.91l.68.09c.77.11,1.14.31,1.14.68,0,.5-.52.79-1.48.79-.77.02-1.53-.22-2.16-.68l-.68,1.1c.82.57,1.81.87,2.81.84,1.87,0,2.96-.88,2.96-2.12s-.85-1.74-2.26-1.94l-.68-.09c-.61-.08-1.1-.2-1.1-.64s.46-.76,1.23-.76c.71,0,1.41.2,2.03.56l.62-1.14ZM104.4,64.88c-.7-.02-1.36.34-1.71.95v-.79h-1.4v6.48h1.41v-3.63c0-1.07.46-1.67,1.36-1.67.3,0,.6.05.88.16l.43-1.36c-.32-.12-.66-.17-1-.18l.03.03ZM86.23,68.27c-.07,1.81,1.34,3.33,3.15,3.39.1,0,.2,0,.31,0,.85.04,1.68-.23,2.33-.77l-.68-1.14c-.49.37-1.08.58-1.69.58-1.15-.09-2-1.1-1.91-2.24.08-1.02.89-1.82,1.91-1.91.61,0,1.21.21,1.69.58l.68-1.14c-.65-.54-1.49-.82-2.33-.77-1.81-.1-3.35,1.28-3.45,3.08,0,.1,0,.2,0,.31v.03ZM99.43,68.27v-3.23h-1.41v.79c-.49-.63-1.24-.98-2.03-.95-1.87,0-3.39,1.52-3.39,3.39s1.52,3.39,3.39,3.39c.79.03,1.55-.32,2.03-.95v.79h1.41v-3.23ZM94.19,68.27c.06-1.08.99-1.9,2.07-1.84,1.08.06,1.9.99,1.84,2.07-.06,1.03-.91,1.84-1.95,1.84-1.07.01-1.96-.85-1.97-1.92,0-.05,0-.1,0-.15ZM77.17,64.88c-1.87.03-3.37,1.56-3.34,3.44.03,1.87,1.56,3.37,3.44,3.34h0c.98.05,1.93-.26,2.69-.88l-.68-1.04c-.54.43-1.2.67-1.88.68-.97.08-1.83-.62-1.94-1.59h4.81v-.54c0-2.03-1.26-3.39-3.08-3.39h-.02ZM77.17,66.14c.89-.02,1.62.68,1.64,1.57h0s-3.39,0-3.39,0c.05-.91.82-1.6,1.72-1.57h.03ZM112.5,68.28v-5.84h-1.36v3.39c-.49-.63-1.24-.98-2.03-.95-1.87,0-3.39,1.52-3.39,3.39s1.52,3.39,3.39,3.39c.79.03,1.55-.32,2.03-.95v.79h1.36v-3.21ZM114.85,70.58c.09,0,.18.02.26.05.08.03.15.08.21.14.06.06.11.13.14.2.07.16.07.34,0,.5-.03.08-.08.14-.14.2-.06.06-.13.1-.21.14-.08.04-.17.05-.26.05-.26,0-.5-.16-.61-.39-.07-.16-.07-.34,0-.5.03-.08.08-.14.14-.2.06-.06.13-.1.21-.14.09-.04.18-.05.28-.05h-.02ZM114.85,71.73c.07,0,.13-.01.2-.04.06-.03.11-.06.16-.11.18-.19.18-.49,0-.68-.04-.05-.1-.08-.16-.11-.06-.03-.13-.04-.2-.04-.07,0-.13.01-.2.04-.06.03-.12.06-.16.11-.18.19-.18.49,0,.68.05.05.1.08.16.11.07.03.14.04.22.04h-.02ZM114.89,70.92c.06,0,.13.02.18.05.04.03.06.09.06.14,0,.05-.02.09-.05.12-.04.04-.09.06-.14.06l.2.22h-.16l-.18-.22h-.06v.22h-.13v-.6h.28ZM114.74,71.03v.16h.15s.05,0,.08,0c0-.02,0-.04,0-.06,0-.02,0-.04,0-.06-.03,0-.05,0-.08,0l-.15-.04ZM107.28,68.28c.06-1.08.99-1.9,2.07-1.84,1.08.06,1.9.99,1.84,2.07-.06,1.03-.91,1.84-1.95,1.84-1.07.01-1.96-.85-1.97-1.92,0-.05,0-.1,0-.15ZM59.68,68.28v-3.24h-1.41v.79c-.49-.63-1.24-.98-2.03-.95-1.87,0-3.39,1.52-3.39,3.39s1.52,3.39,3.39,3.39c.79.03,1.55-.32,2.03-.95v.79h1.41v-3.21ZM54.43,68.28c.06-1.08.99-1.9,2.07-1.84,1.08.06,1.9.99,1.84,2.07-.06,1.03-.91,1.84-1.95,1.84-1.07.02-1.96-.83-1.98-1.91,0-.06,0-.11,0-.17h.01Z"
        />
    `,
  },
  logoOld: {
    viewBox: '0 0 51 33',
    src: svg`
      <style>
        .svg {
          stroke-miterlimit: 10;
        }

        .svg-1 {
          stroke-width: 1.2375px;
        }

        .svg-2 {
          stroke-width: 0.90625px;
        }

        .svg-3 {
          stroke-width: 1.2375px;
        }

        .svg-4 {
          stroke-width: 1px;
        }
      </style>

      <circle class="svg svg-1" cx="6.22" cy="13.14" r="4.97"/>
      <circle class="svg svg-1" cx="23.52" cy="9.87" r="5.77"/>
      <circle class="svg svg-2" cx="14.35" cy="25.15" r="2.3"/>
      <circle class="svg svg-3" cx="40.09" cy="25.29" r="6.4"/>
      <circle class="svg svg-2" cx="45.9" cy="4.49" r="3.35"/>
      <line class="svg svg-4" x1="11.19" y1="13.14" x2="18.21" y2="12.12"/>
      <line class="svg svg-4" x1="20.43" y1="14.73" x2="15.63" y2="23.24"/>
      <line class="svg svg-4" x1="27.86" y1="13.66" x2="35.96" y2="20.4"/>
      <line class="svg svg-4" x1="28.91" y1="7.83" x2="42.56" y2="5.63"/>
    `,
  },
  logoVisa: {
    viewBox: '0 0 154.21 81.6',
    src: svg`
      <defs>
        <style>
          .cls-1 {
            fill: #fff;
            stroke-width: 0px;
          }
        </style>
      </defs>
      <path class="cls-1" d="M79.19,33.73c-.07,5.45,4.86,8.49,8.57,10.3,3.81,1.86,5.09,3.05,5.08,4.7-.05,4.68-8.7,4.69-15.92,1.31l-1.77,8.29c9.36,4.32,27.87,2.49,27.93-10.94.04-9.99-13.82-10.54-13.72-15.01.11-4.66,9.47-3.47,13.81-1.47l1.72-8.02c-13.22-4.81-25.63,1.03-25.7,10.83"/>
      <path class="cls-1" d="M129.79,21.91h-8.36c-1.88,0-3.46,1.1-4.17,2.78l-14.69,35.07h10.28l2.05-5.65h12.56l1.19,5.65h9.06l-7.9-37.85ZM117.71,46.35l5.16-14.21,2.97,14.21h-8.12Z"/>
      <polyline class="cls-1" points="66.73 21.91 58.63 59.76 68.42 59.76 76.52 21.91 66.73 21.91"/>
      <path class="cls-1" d="M52.24,21.91l-10.19,25.76-4.12-21.9c-.48-2.45-2.39-3.86-4.52-3.86h-16.66l-.23,1.1c7.21,1.56,11.03,2.77,11.99,6.55l7.81,30.2h10.35l15.86-37.85h-10.28"/>
    `,
  },
  logout: {
    viewBox: '0 0 24 24',
    src: svg`
      <path xmlns="http://www.w3.org/2000/svg" d="M0 0h24v24H0z" fill="none"/>
      <path xmlns="http://www.w3.org/2000/svg" d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
    `,
  },
  loop: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    `,
  },
  macroReport: {
    viewBox: '0 0 48 48',
    src: svg`
      <path d="M16.5 42 6 31.5V16.5L16.5 6H31.5L42 16.5V31.5L31.5 42ZM24 33.95Q24.7 33.95 25.225 33.425Q25.75 32.9 25.75 32.2Q25.75 31.5 25.225 30.975Q24.7 30.45 24 30.45Q23.3 30.45 22.775 30.975Q22.25 31.5 22.25 32.2Q22.25 32.9 22.775 33.425Q23.3 33.95 24 33.95ZM22.5 26.75H25.5V13.6H22.5ZM17.75 39H30.25L39 30.25V17.75L30.25 9H17.75L9 17.75V30.25ZM24 24Z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    `,
  },
  medicalInsurance: {
    viewBox: '0 0 26.011 30',
    src: svg`
      <g transform="translate(-55.038 -369)">
        <g transform="translate(55.038 369)">
          <path class="a" d="M56.965,4.115A13.912,13.912,0,0,1,47.682.571L47.044,0,46.4.571a13.912,13.912,0,0,1-9.283,3.544H34.038v6.758A20.507,20.507,0,0,0,45.894,29.465l1.15.535,1.15-.535A20.507,20.507,0,0,0,60.049,10.872V4.115Zm1.326,6.758a18.748,18.748,0,0,1-10.839,17l-.408.19-.408-.19a18.748,18.748,0,0,1-10.839-17v-5h1.326a15.665,15.665,0,0,0,9.921-3.535,15.666,15.666,0,0,0,9.921,3.535h1.326v5Z" transform="translate(-34.038)"/>
        </g>

        <text class="b" transform="translate(64.038 390)">
          <tspan x="0" y="0">+</tspan>
        </text>
      </g>
    `,
  },
  preallocatePayment: {
    viewBox: '0 0 26.011 30',
    src: svg`
      <svg xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; overflow: visible; fill: rgb(57, 183, 224);" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none"></path>
        <path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"></path>
      </svg>
    `,
  },
  menu: {
    viewBox: '0 0 29.221 23',
    src: svg`
    <g transform="translate(-22 -46)">
      <rect width="29.221" height="3" rx="1.5" transform="translate(22 46)" fill="#fff"/>
      <rect width="29.221" height="3" rx="1.5" transform="translate(22 56)" fill="#fff"/>
      <rect width="29.221" height="3" rx="1.5" transform="translate(22 66)" fill="#fff"/>
    </g>
  `,
  },
  minus: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
    `,
  },
  minusOnly: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M19 13H5v-2h14v2z"/><path d="M0 0h24v24H0z" fill="none"/>`,
  },
  noDocuments: {
    viewBox: '0 0 60 60',
    src: svg`
      <path
        d="M38.914,0H6.5v60h47V14.586L38.914,0z M39.5,3.414L50.086,14H39.5V3.414z M8.5,58V2h29v14h14v42H8.5z"
      />
      <path
        d="M16.5,17h9c0.552,0,1-0.447,1-1s-0.448-1-1-1h-9c-0.552,0-1,0.447-1,1S15.948,17,16.5,17z"
      />
      <path
        d="M33.5,37h-17c-0.552,0-1,0.447-1,1s0.448,1,1,1h17c0.552,0,1-0.447,1-1S34.052,37,33.5,37z"
      />
      <path
        d="M43.5,30h-7c-0.552,0-1,0.447-1,1s0.448,1,1,1h7c0.552,0,1-0.447,1-1S44.052,30,43.5,30z"
      />
      <path
        d="M16.5,25h5c0.552,0,1-0.447,1-1s-0.448-1-1-1h-5c-0.552,0-1,0.447-1,1S15.948,25,16.5,25z"
      />
      <path
        d="M31.5,25h7c0.552,0,1-0.447,1-1s-0.448-1-1-1h-7c-0.552,0-1,0.447-1,1S30.948,25,31.5,25z"
      />
      <path
        d="M25.5,24c0,0.26,0.11,0.52,0.29,0.71C25.98,24.89,26.24,25,26.5,25c0.26,0,0.52-0.11,0.71-0.29
c0.18-0.19,0.29-0.45,0.29-0.71c0-0.261-0.11-0.521-0.29-0.71c-0.37-0.37-1.04-0.37-1.42,0C25.61,23.479,25.5,23.739,25.5,24z"
      />
      <path
        d="M21.5,30c-0.552,0-1,0.447-1,1s0.448,1,1,1h10c0.552,0,1-0.447,1-1s-0.448-1-1-1H21.5z"
      />
      <path
        d="M16.5,32c0.26,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.261-0.11-0.521-0.29-0.71
c-0.37-0.37-1.05-0.37-1.42,0c-0.18,0.189-0.29,0.439-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71C15.98,31.89,16.24,32,16.5,32z"
      />
      <path
        d="M43.5,44h-7c-0.552,0-1,0.447-1,1s0.448,1,1,1h7c0.552,0,1-0.447,1-1S44.052,44,43.5,44z"
      />
      <path
        d="M31.5,44h-10c-0.552,0-1,0.447-1,1s0.448,1,1,1h10c0.552,0,1-0.447,1-1S32.052,44,31.5,44z"
      />
      <path
        d="M15.79,44.29c-0.18,0.18-0.29,0.439-0.29,0.71c0,0.27,0.1,0.52,0.29,0.71C15.98,45.89,16.24,46,16.5,46
c0.27,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.271-0.11-0.521-0.29-0.7C16.84,43.92,16.17,43.92,15.79,44.29z"
      />
      <path
        d="M42.79,23.29c-0.18,0.189-0.29,0.449-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71C42.98,24.89,43.24,25,43.5,25
c0.26,0,0.52-0.11,0.71-0.29c0.19-0.19,0.29-0.45,0.29-0.71c0-0.261-0.1-0.521-0.29-0.71C43.83,22.92,43.17,22.92,42.79,23.29z"
      />
      <path
        d="M39.21,38.71c0.18-0.19,0.29-0.45,0.29-0.71c0-0.261-0.11-0.521-0.29-0.71c-0.38-0.37-1.05-0.37-1.42,0
c-0.18,0.189-0.29,0.449-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71C37.98,38.899,38.23,39,38.5,39S39.02,38.89,39.21,38.71z"
      />
      <path
        d="M42.79,37.29c-0.18,0.189-0.29,0.449-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71C42.98,38.89,43.23,39,43.5,39
s0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.261-0.11-0.521-0.29-0.71C43.84,36.92,43.16,36.92,42.79,37.29z"
      />
    `,
  },
  noShow: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    `,
  },
  noteAdd: {
    viewBox: '0 0 16 20',
    src: svg`
      <style type="text/css">
        .st0{fill:none;}
      </style>

      <path class="st0" d="M-4-2h24v24H-4V-2z"/>
      <path class="st1" d="M10,0H2C0.9,0,0,0.9,0,2l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V6L10,0z M12,14H9v3H7v-3H4v-2h3V9h2v3h3V14z
        M9,7V1.5L14.5,7H9z"/>
    `,
  },
  notification: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"></path>
    `,
  },
  notification_important: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z"/>
    `,
  },
  offset: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"/>
    `,
  },
  outlinedFlag: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"/>`,
  },
  open: {
    viewBox: '0 0 18 18',
    src: svg`<path d="M16,16H2V2h7V0H2C0.9,0,0,0.9,0,2v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V9h-2V16z M11,0v2h3.6l-9.8,9.8l1.4,1.4L16,3.4V7h2
    V0H11z"/>`,
  },
  organization: {
    viewBox: '0 0 24 24',
    src: svg`
      <path fill="none" d="M0 0h24v24H0V0z"/>
      <path d="M12 7V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-8zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm9 12h-7v-2h2v-2h-2v-2h2v-2h-2V9h7c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-1-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
    `,
  },
  paperClaims: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M0 0h24v24H0z" fill="none"/><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>`,
  },
  patients: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
    `,
  },
  person: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/><path d="M0 0h24v24H0z" fill="none"/>`,
  },
  personChart: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M0 0h24v24H0z" fill="none"/><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>`,
  },
  pdf: {
    viewBox: '0 0 24.02 29',
    src: svg`
      <image width="32" height="32" transform="translate(-4 -1)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAACtklEQVRYCe2XTWjTYBzGn7RN1wkdu1XWebCXlSKenC2iCLPzUBALfqAg1F0m2PpxELGIIjsUPQhO7cQxpmWHgR+wiwq1lQmCK3oRRomXiqDDHgaajrVdm0Ted1uxJG2TNNsuPlDom7zJ/5fn+b9vCCNJErZSFlltl6MbwAyAg21wfQdwC7n801YT5Q64HLPCvgO/V+4+PCrZuzRXZgo8LBOP/rCJCRbV6nPk8me1AkilF68guj2ai/8rE5eF7XSwiErlWTMIk9LBdouv36M0PdMJlj0Jl6NhFIoARkkNhG4AczqJbbt2otO3m+beSDUIi+UEXA5ZFLoB2KlJkF5hlgoUppkIxMrVG4sAjAPA2o3FPV4wCz9azhWOBHcoLW3dAKKzF+ZPczB9zkAYONxyfqMlrRtACB6H9cIwpB5nW6tGvwNuD80fPN+0CTcMgDRe9cwQJLcH7O0R3QDyd4FKsWP3UL4/TrO1HQvAxgUAexdtSGbhJ4SBQVTOX24Zj2YHyJN3XBym1lumJmEbOrUaBYDyg3EUkx9Q/PgFDM/Dev2KcQ6QwtY7IxD6fXQs7vVB7PfRZhR7emF+l4RtcD+NhIjhsnROKym+jJbnv9UdspKMCzwq125SEGJ/6eVr2dIizUjOkxjEPg+EQ/XLk+ycyOWZumvUAJALy6OPYfqaBTs2ivKT6ZoTWqQEoCoC0u0dl87RNU9A9BRvJFUOGCUlBzb0daxGmgC8Xi/9xePx2tjv9yOdTsvOqZXmjSiVStGi4XCYjhOJBEKhEP2fyWQ21gEinq/f951OJwqF1Y2IOEDc0CLNDpCnjUajtTHHcbDb7RRiUxwgEQSDwdo4EokgFotpLryu/8tQCeC9+e2bZcMLZeeX1j7Z6qQUQbfk2D7H5H/1GUrAsuQrKYBcfrY5wCZra3sAwF8ksiYS0DOdWwAAAABJRU5ErkJggg=="/>
    `,
  },
  plus: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
    `,
  },
  plusOnly: {
    viewBox: '0 0 10.385 10.385',
    src: svg`<path d="M22.5,17.615H18.077V13.385a.385.385,0,1,0-.769,0v4.231H12.885a.385.385,0,1,0,0,.769h4.423V23a.385.385,0,1,0,.769,0V18.385H22.5a.385.385,0,1,0,0-.769Z" transform="translate(-12.5 -13)"/>`,
  },
  practices: {
    viewBox: '0 0 24 24',
    src: svg`
        <g>
          <rect fill="none" height="24" width="24"/>
        </g>
        <g>
          <path d="M17,11V3H7v4H3v14h8v-4h2v4h8V11H17z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11z M11,15H9v-2h2V15z M11,11H9V9h2 V11z M11,7H9V5h2V7z M15,15h-2v-2h2V15z M15,11h-2V9h2V11z M15,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z"/>
        </g>
      `,
  },
  preview: {
    viewBox: '0 0 45 45',
    src: svg`
    <path d="M9 42q-1.25 0-2.125-.875T6 39V9q0-1.25.875-2.125T9 6h30q1.25 0 2.125.875T42 9v30q0 1.25-.875 2.125T39 42Zm0-3h30V13H9v26Zm15-5.25q-4 0-7.15-2.15-3.15-2.15-4.6-5.6 1.45-3.45 4.6-5.6Q20 18.25 24 18.25t7.15 2.15q3.15 2.15 4.6 5.6-1.45 3.45-4.6 5.6Q28 33.75 24 33.75Zm0-2.5q2.85 0 5.25-1.4T33 26q-1.35-2.45-3.75-3.85T24 20.75q-2.85 0-5.25 1.4T15 26q1.35 2.45 3.75 3.85t5.25 1.4Zm0-2.75q-1.05 0-1.775-.725Q21.5 27.05 21.5 26q0-1.05.725-1.775Q22.95 23.5 24 23.5q1.05 0 1.775.725.725.725.725 1.775 0 1.05-.725 1.775-.725.725-1.775.725Z"/>`,
  },
  print: {
    viewBox: '0 0 22 22',
    src: svg`
    <path  d="M19,8H5a3,3,0,0,0-3,3v6H6v4H18V17h4V11A3,3,0,0,0,19,8ZM16,19H8V14h8Zm3-7a1,1,0,1,1,1-1A1,1,0,0,1,19,12ZM18,3H6V7H18Z" d="M0,0H24V24H0Z"/>`,
  },
  generateSubmit: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M17.66,9.53l-7.07,7.07l-4.24-4.24l1.41-1.41l2.83,2.83l5.66-5.66L17.66,9.53z M4,12c0-2.33,1.02-4.42,2.62-5.88L9,8.5v-6H3 l2.2,2.2C3.24,6.52,2,9.11,2,12c0,5.19,3.95,9.45,9,9.95v-2.02C7.06,19.44,4,16.07,4,12z M22,12c0-5.19-3.95-9.45-9-9.95v2.02 c3.94,0.49,7,3.86,7,7.93c0,2.33-1.02,4.42-2.62,5.88L15,15.5v6h6l-2.2-2.2C20.76,17.48,22,14.89,22,12z"/>`,
  },
  radioButtonUnchecked: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path class="st0" d="M12,2c5.5,0,10,4.5,10,10s-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2 M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0L12,0z"/>
      </g>
    `,
  },
  realTimeEligibility: {
    viewBox: '0 0 24 24',
    src: svg`
    <g><rect fill="none" height="24" width="24"/></g><g><g>
    <path d="M20,3H4C2.9,3,2,3.9,2,5v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V5 C22,3.9,21.1,3,20,3z M10,17H5v-2h5V17z M10,13H5v-2h5V13z M10,9H5V7h5V9z M14.82,15L12,12.16l1.41-1.41l1.41,1.42L17.99,9 l1.42,1.42L14.82,15z" fill-rule="evenodd"/></g></g>
    `,
  },
  receipt: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"/><path d="M0 0h24v24H0z" fill="none"/>`,
  },
  refresh: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
    `,
  },
  refund: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
    `,
  },
  reorder: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"/>
    `,
  },
  replace: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"/>
    `,
  },
  reports: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <rect fill="none" height="24" width="24"/>
        <path d="M19,7H9C7.9,7,7,7.9,7,9v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V9C21,7.9,20.1,7,19,7z M19,9v2H9V9H19z M13,15v-2h2v2H13z M15,17v2h-2v-2H15z M11,15H9v-2h2V15z M17,13h2v2h-2V13z M9,17h2v2H9V17z M17,19v-2h2v2H17z M6,17H5c-1.1,0-2-0.9-2-2V5 c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v1h-2V5H5v10h1V17z"/>
      </g>
    `,
  },
  requestReview: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/>
    `,
  },
  rescheduled: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"/>
    `,
  },
  resend: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
    `,
  },
  refreshAndSubmit: {
    viewBox: '0 0 24 24',
    src: svg`
    <path xmlns="http://www.w3.org/2000/svg" d="M17.66,9.53l-7.07,7.07l-4.24-4.24l1.41-1.41l2.83,2.83l5.66-5.66L17.66,9.53z M4,12c0-2.33,1.02-4.42,2.62-5.88L9,8.5v-6H3 l2.2,2.2C3.24,6.52,2,9.11,2,12c0,5.19,3.95,9.45,9,9.95v-2.02C7.06,19.44,4,16.07,4,12z M22,12c0-5.19-3.95-9.45-9-9.95v2.02 c3.94,0.49,7,3.86,7,7.93c0,2.33-1.02,4.42-2.62,5.88L15,15.5v6h6l-2.2-2.2C20.76,17.48,22,14.89,22,12z"/>
    `,
  },
  return: {
    viewBox: '2 2 20 20',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
    `,
  },
  roomDoor: {
    viewBox: '0 0 24 24',
    src: svg`<g><rect fill="none" height="24" width="24"/><path d="M18,2H6C4.9,2,4,2.9,4,4v18h16V4C20,2.9,19.1,2,18,2z M15.5,13.5c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5 S17,11.17,17,12S16.33,13.5,15.5,13.5z"/></g>`,
  },
  rotateCCW: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"/>
    `,
  },
  rteWarning: {
    viewBox: '0 0 24 20.7',
    src: svg`
      <style type="text/css">
        .st0{fill:none;}
      </style>

      <path class="st0" d="M0-1.1h24v24H0V-1.1z"/>
      <path d="M0,20.7h24L12,0L0,20.7z M13.1,17.5h-2.2v-2.2h2.2V17.5z M13.1,13.1h-2.2V8.7h2.2V13.1z"/>
    `,
  },
  rules: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <rect fill="none" height="24" width="24"/>
        <path d="M16.54,11L13,7.46l1.41-1.41l2.12,2.12l4.24-4.24l1.41,1.41L16.54,11z M11,7H2v2h9V7z M21,13.41L19.59,12L17,14.59 L14.41,12L13,13.41L15.59,16L13,18.59L14.41,20L17,17.41L19.59,20L21,18.59L18.41,16L21,13.41z M11,15H2v2h9V15z"/>
      </g>
    `,
  },
  search: {
    viewBox: '0 0 17.93 17.93',
    src: svg`
      <style>
        .shape {
          fill: #959595;
          stroke: none;
          stroke-width: 0;
        }
      </style>

      <path class="shape" d="M12.7,11.2h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,5,1.49-1.49Zm-6,0a4.5,4.5,0,1,1,4.5-4.5A4.49,4.49,0,0,1,6.7,11.2Z"/>
    `,
  },
  selfCheckIn: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none" fill-rule="evenodd"/>
      <g fill-rule="evenodd">
        <path d="M9 17l3-2.94c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4"/>
        <path d="M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z"/>
      </g>
    `,
  },
  settings: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
    `,
  },
  timing: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>
    `,
  },
  settingsNew: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"/>
    `,
  },
  shoppingCart: {
    viewBox: '0 0 27.866 30',
    src: svg`
    <g id="shopping-cart-2" transform="translate(-292.25 -322)">
      <g id="Group_2611" data-name="Group 2611" transform="translate(17.25 0)">
        <path id="Path_466" data-name="Path 466" d="M25.153,19.694H41.788a3.333,3.333,0,0,0,3.328-3.328V9.357a.742.742,0,1,0-1.485,0v7A1.844,1.844,0,0,1,41.788,18.2H25.153A1.844,1.844,0,0,1,23.31,16.36V2.676A.353.353,0,0,0,23.3,2.6V2.577c0-.019-.006-.037-.006-.049a.115.115,0,0,0-.012-.043c0-.006-.006-.019-.006-.025s-.012-.031-.019-.049-.006-.012-.006-.019-.012-.031-.019-.043-.006-.019-.012-.025L23.2,2.286c-.006-.012-.012-.019-.019-.031s-.012-.019-.019-.025a.135.135,0,0,0-.025-.031l-.019-.019c-.012-.012-.019-.025-.031-.037s-.012-.012-.019-.012a.164.164,0,0,0-.037-.031l-.019-.019c-.012-.006-.025-.019-.037-.025s-.031-.019-.043-.031a.013.013,0,0,1-.012-.012l-.074-.037L18.281.059a.742.742,0,0,0-.575,1.367l4.114,1.738v18.41a3.328,3.328,0,0,0,3.05,3.316,3.289,3.289,0,1,0,5.493.012h7.875a3.292,3.292,0,1,0,2.753-1.485H25.153a1.844,1.844,0,0,1-1.843-1.843V19.131A3.309,3.309,0,0,0,25.153,19.694Zm4.262,7.015A1.806,1.806,0,1,1,27.609,24.9,1.808,1.808,0,0,1,29.416,26.709Zm13.374,0A1.806,1.806,0,1,1,40.984,24.9,1.808,1.808,0,0,1,42.79,26.709Z" transform="translate(257.75 322)"/>
      </g>
    </g>`,
  },
  signed: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"/>
    `,
  },
  solidFlag: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"/>`,
  },
  split: {
    viewBox: '0 0 24 24',
    src: svg`

    <style type="text/css">
      .st0{fill:none;}
    </style>

    <path class="st0" d="M0,0h24v24H0V0z"/>
    <path d="M20,14l-2.3,2.3l-2.9-2.9l-1.4,1.4l2.9,2.9L14,20h6V14z M20,10V4h-6l2.3,2.3L11.6,11H4v2h8.4l5.3-5.3L20,10z"/>
    `,
  },
  splitAppointment: {
    viewBox: '0 0 24 24',
    src: svg`
    <g><g><path d="M17,4v16c1.1,0,2-0.9,2-2V6C19,4.9,18.1,4,17,4z"/><path d="M13,2H4C2.9,2,2,2.9,2,4v16c0,1.1,0.9,2,2,2h9c1.1,0,2-0.9,2-2V4C15,2.9,14.1,2,13,2z M13,20H4V4h9V20z"/><path d="M21,6v12c0.83,0,1.5-0.67,1.5-1.5v-9C22.5,6.67,21.83,6,21,6z"/></g></g>
    `,
  },
  tenants: {
    viewBox: '0 0 332.8 332.8',
    src: svg`
      <g><g><path d="M326.4,309.6h-28V16c0-3.2-3.2-5.6-6.4-5.6H40.8c-3.2,0-5.6,2.4-5.6,6.4v292.8H6.4C3.2,309.6,0,312,0,316 c0,3.2,2.4,6.4,6.4,6.4h34.4h80h90.4h80h35.2c3.2,0,6.4-2.4,6.4-6.4C332.8,312.8,330.4,309.6,326.4,309.6z M160.8,308.8h-33.6 v-79.2h33.6V308.8z M206.4,308.8h-33.6v-79.2h33.6V308.8z M286.4,309.6h-68.8v-0.8V224c0-3.2-2.4-6.4-6.4-6.4h-90.4 c-3.2,0-6.4,2.4-6.4,6.4v85.6h-68V22.4h240V309.6z"/></g></g><g><g><path d="M113.6,66.4H79.2c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,6.4,6.4,6.4h34.4c3.2,0,6.4-2.4,6.4-6.4 C119.2,68.8,116.8,66.4,113.6,66.4z"/></g></g><g><g><path d="M183.2,66.4h-34.4c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,6.4,6.4,6.4h34.4c3.2,0,6.4-2.4,6.4-6.4S186.4,66.4,183.2,66.4z"/></g></g><g><g><path d="M253.6,66.4h-34.4c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,6.4,6.4,6.4h34.4c3.2,0,6.4-2.4,6.4-6.4 C259.2,68.8,256.8,66.4,253.6,66.4z"/></g></g><g><g><path d="M113.6,110.4H79.2c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,6.4,6.4,6.4h34.4c3.2,0,6.4-2.4,6.4-6.4 C119.2,112.8,116.8,110.4,113.6,110.4z"/></g></g><g><g><path d="M183.2,110.4h-34.4c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,6.4,6.4,6.4h34.4c3.2,0,6.4-2.4,6.4-6.4S186.4,110.4,183.2,110.4z"/></g></g><g><g><path d="M253.6,110.4h-34.4c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,6.4,6.4,6.4h34.4c3.2,0,6.4-2.4,6.4-6.4 C259.2,112.8,256.8,110.4,253.6,110.4z"/></g></g><g><g><path d="M113.6,154.4H79.2c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,5.6,6.4,5.6h34.4c3.2,0,6.4-2.4,6.4-5.6 C119.2,156.8,116.8,154.4,113.6,154.4z"/></g></g><g><g><path d="M183.2,154.4h-34.4c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,5.6,6.4,5.6h34.4c3.2,0,6.4-2.4,6.4-5.6 C189.6,156.8,186.4,154.4,183.2,154.4z"/></g></g><g><g><path d="M253.6,154.4h-34.4c-3.2,0-6.4,2.4-6.4,6.4c0,3.2,2.4,5.6,6.4,5.6h34.4c3.2,0,6.4-2.4,6.4-5.6 C259.2,156.8,256.8,154.4,253.6,154.4z"/></g></g>
    `,
  },
  unsigned: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"/>
    `,
  },
  undo: {
    viewBox: '0 0 24 24',
    src: svg`
      <g id="undo"><path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"></path></g>
    `,
  },
  updateAll: {
    viewBox: '0 0 20 28',
    src: svg`
      <style type="text/css">
        .st0{enable-background:new    ;}
        .st2{fill:none;}
      </style>

      <g id="Group_2675" transform="translate(-1111 -530)">
        <g id="Group_2649" transform="translate(483.688 283)">
          <g class="st0">
            <path class="st1" d="M634.2,273l-0.4-1.4h-2.1l-0.4,1.4H630l2-5.7h1.5l2,5.7H634.2z M633.5,270.6c-0.4-1.2-0.6-1.9-0.6-2.1
              s-0.1-0.3-0.1-0.4c-0.1,0.3-0.3,1.2-0.7,2.5H633.5z"/>
            <path class="st1" d="M636.3,273v-5.7h1.2v4.7h2.3v1H636.3z"/>
            <path class="st1" d="M640.8,273v-5.7h1.2v4.7h2.3v1H640.8z"/>
          </g>
        </g>

        <g id="_24px_1_" transform="translate(1111 529.5)">
          <path id="Path_776" class="st2" d="M0,0.5h20v20H0V0.5z"/>

          <path id="Path_777" class="st1" d="M10,13.6l3.3-3.1h-2.5v-7H9.2v7H6.7L10,13.6z M17.4,3.5h-4.9V5h4.9V16H2.6V5h4.9V3.5H2.6
            C1.8,3.5,1,4.2,1,5.1v10.9c0,0.9,0.8,1.6,1.6,1.6h14.7c0.9,0,1.6-0.7,1.6-1.6V5.1C19,4.2,18.2,3.5,17.4,3.5z"/>
        </g>
      </g>
    `,
  },
  upload: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
    `,
  },
  uploadNew: {
    viewBox: '0 0 24 24',
    src: svg`
      <g transform="rotate(180 12 12)">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </g>
    `,
  },
  user: {
    viewBox: '0 0 56 56',
    src: svg`
      <path d="M55,27.5C55,12.337,42.663,0,27.5,0S0,12.337,0,27.5c0,8.009,3.444,15.228,8.926,20.258l-0.026,0.023l0.892,0.752 c0.058,0.049,0.121,0.089,0.179,0.137c0.474,0.393,0.965,0.766,1.465,1.127c0.162,0.117,0.324,0.234,0.489,0.348 c0.534,0.368,1.082,0.717,1.642,1.048c0.122,0.072,0.245,0.142,0.368,0.212c0.613,0.349,1.239,0.678,1.88,0.98 c0.047,0.022,0.095,0.042,0.142,0.064c2.089,0.971,4.319,1.684,6.651,2.105c0.061,0.011,0.122,0.022,0.184,0.033 c0.724,0.125,1.456,0.225,2.197,0.292c0.09,0.008,0.18,0.013,0.271,0.021C25.998,54.961,26.744,55,27.5,55 c0.749,0,1.488-0.039,2.222-0.098c0.093-0.008,0.186-0.013,0.279-0.021c0.735-0.067,1.461-0.164,2.178-0.287 c0.062-0.011,0.125-0.022,0.187-0.034c2.297-0.412,4.495-1.109,6.557-2.055c0.076-0.035,0.153-0.068,0.229-0.104 c0.617-0.29,1.22-0.603,1.811-0.936c0.147-0.083,0.293-0.167,0.439-0.253c0.538-0.317,1.067-0.648,1.581-1 c0.185-0.126,0.366-0.259,0.549-0.391c0.439-0.316,0.87-0.642,1.289-0.983c0.093-0.075,0.193-0.14,0.284-0.217l0.915-0.764 l-0.027-0.023C51.523,42.802,55,35.55,55,27.5z M2,27.5C2,13.439,13.439,2,27.5,2S53,13.439,53,27.5 c0,7.577-3.325,14.389-8.589,19.063c-0.294-0.203-0.59-0.385-0.893-0.537l-8.467-4.233c-0.76-0.38-1.232-1.144-1.232-1.993v-2.957 c0.196-0.242,0.403-0.516,0.617-0.817c1.096-1.548,1.975-3.27,2.616-5.123c1.267-0.602,2.085-1.864,2.085-3.289v-3.545 c0-0.867-0.318-1.708-0.887-2.369v-4.667c0.052-0.519,0.236-3.448-1.883-5.864C34.524,9.065,31.541,8,27.5,8 s-7.024,1.065-8.867,3.168c-2.119,2.416-1.935,5.345-1.883,5.864v4.667c-0.568,0.661-0.887,1.502-0.887,2.369v3.545 c0,1.101,0.494,2.128,1.34,2.821c0.81,3.173,2.477,5.575,3.093,6.389v2.894c0,0.816-0.445,1.566-1.162,1.958l-7.907,4.313 c-0.252,0.137-0.502,0.297-0.752,0.476C5.276,41.792,2,35.022,2,27.5z M42.459,48.132c-0.35,0.254-0.706,0.5-1.067,0.735 c-0.166,0.108-0.331,0.216-0.5,0.321c-0.472,0.292-0.952,0.57-1.442,0.83c-0.108,0.057-0.217,0.111-0.326,0.167 c-1.126,0.577-2.291,1.073-3.488,1.476c-0.042,0.014-0.084,0.029-0.127,0.043c-0.627,0.208-1.262,0.393-1.904,0.552 c-0.002,0-0.004,0.001-0.006,0.001c-0.648,0.16-1.304,0.293-1.964,0.402c-0.018,0.003-0.036,0.007-0.054,0.01 c-0.621,0.101-1.247,0.174-1.875,0.229c-0.111,0.01-0.222,0.017-0.334,0.025C28.751,52.97,28.127,53,27.5,53 c-0.634,0-1.266-0.031-1.895-0.078c-0.109-0.008-0.218-0.015-0.326-0.025c-0.634-0.056-1.265-0.131-1.89-0.233 c-0.028-0.005-0.056-0.01-0.084-0.015c-1.322-0.221-2.623-0.546-3.89-0.971c-0.039-0.013-0.079-0.027-0.118-0.04 c-0.629-0.214-1.251-0.451-1.862-0.713c-0.004-0.002-0.009-0.004-0.013-0.006c-0.578-0.249-1.145-0.525-1.705-0.816 c-0.073-0.038-0.147-0.074-0.219-0.113c-0.511-0.273-1.011-0.568-1.504-0.876c-0.146-0.092-0.291-0.185-0.435-0.279 c-0.454-0.297-0.902-0.606-1.338-0.933c-0.045-0.034-0.088-0.07-0.133-0.104c0.032-0.018,0.064-0.036,0.096-0.054l7.907-4.313 c1.36-0.742,2.205-2.165,2.205-3.714l-0.001-3.602l-0.23-0.278c-0.022-0.025-2.184-2.655-3.001-6.216l-0.091-0.396l-0.341-0.221 c-0.481-0.311-0.769-0.831-0.769-1.392v-3.545c0-0.465,0.197-0.898,0.557-1.223l0.33-0.298v-5.57l-0.009-0.131 c-0.003-0.024-0.298-2.429,1.396-4.36C21.583,10.837,24.061,10,27.5,10c3.426,0,5.896,0.83,7.346,2.466 c1.692,1.911,1.415,4.361,1.413,4.381l-0.009,5.701l0.33,0.298c0.359,0.324,0.557,0.758,0.557,1.223v3.545 c0,0.713-0.485,1.36-1.181,1.575l-0.497,0.153l-0.16,0.495c-0.59,1.833-1.43,3.526-2.496,5.032c-0.262,0.37-0.517,0.698-0.736,0.949 l-0.248,0.283V39.8c0,1.612,0.896,3.062,2.338,3.782l8.467,4.233c0.054,0.027,0.107,0.055,0.16,0.083 C42.677,47.979,42.567,48.054,42.459,48.132z"/>
    `,
  },
  userX: {
    viewBox: '0 0 24 24',
    src: svg`
      <style type="text/css">
	      .st0{fill:none;}
      </style>

      <path class="st0" d="M0,0h24v24H0V0z"/>

      <path d="M7.7,7.5c1,0,1.9,0.8,1.9,1.9s-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9S6.7,7.5,7.7,7.5 M7.7,15.6c2.7,0,5.5,1.3,5.5,1.9v1h-11v-1
        C2.2,16.9,5.1,15.6,7.7,15.6 M7.7,5.7c-2,0-3.6,1.6-3.6,3.6S5.7,13,7.7,13s3.6-1.6,3.6-3.6S9.7,5.7,7.7,5.7z M7.7,13.9
        c-2.4,0-7.2,1.2-7.2,3.6v2.7H15v-2.7C15,15.1,10.2,13.9,7.7,13.9z"/>

      <polygon points="18.8,9.1 21.7,6.3 20.3,4.9 17.4,7.7 14.6,4.9 13.2,6.3 16,9.1 13.2,11.9 14.6,13.4 17.4,10.5 20.3,13.4 21.7,11.9"/>
    `,
  },
  userCheck: {
    viewBox: '0 0 24 24',
    src: svg`
      <style type="text/css">
        .st0{fill:none;}
      </style>

      <path class="st0" d="M0,0h24v24H0V0z"/>

      <path d="M7.7,7.5c1,0,1.9,0.8,1.9,1.9s-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9S6.7,7.5,7.7,7.5 M7.7,15.6c2.7,0,5.5,1.3,5.5,1.9v1h-11v-1
        C2.2,16.9,5.1,15.6,7.7,15.6 M7.7,5.7c-2,0-3.6,1.6-3.6,3.6S5.7,13,7.7,13s3.6-1.6,3.6-3.6S9.7,5.7,7.7,5.7z M7.7,13.9
        c-2.4,0-7.2,1.2-7.2,3.6v2.7H15v-2.7C15,15.1,10.2,13.9,7.7,13.9z"/>

      <polygon points="22,5.1 23.5,6.6 16.5,13.6 12,9.1 13.5,7.6 16.5,10.6 "/>
    `,
  },
  userProvider: {
    viewBox: '0 0 85.5 56.2',
    src: svg`
      <path d="M84.3,28.1c0-15.2-12.3-27.5-27.5-27.5S29.3,12.9,29.3,28.1c0,8,3.4,15.2,8.9,20.3l0,0l0.9,0.8c0.1,0,0.1,0.1,0.2,0.1
      c0.5,0.4,1,0.8,1.5,1.1c0.2,0.1,0.3,0.2,0.5,0.3c0.5,0.4,1.1,0.7,1.6,1c0.1,0.1,0.2,0.1,0.4,0.2c0.6,0.3,1.2,0.7,1.9,1
      c0,0,0.1,0,0.1,0.1c2.1,1,4.3,1.7,6.7,2.1c0.1,0,0.1,0,0.2,0c0.7,0.1,1.5,0.2,2.2,0.3c0.1,0,0.2,0,0.3,0c0.7,0.1,1.5,0.1,2.2,0.1
      c0.7,0,1.5,0,2.2-0.1c0.1,0,0.2,0,0.3,0c0.7-0.1,1.5-0.2,2.2-0.3c0.1,0,0.1,0,0.2,0c2.3-0.4,4.5-1.1,6.6-2.1c0.1,0,0.2-0.1,0.2-0.1
      c0.6-0.3,1.2-0.6,1.8-0.9c0.1-0.1,0.3-0.2,0.4-0.3c0.5-0.3,1.1-0.6,1.6-1c0.2-0.1,0.4-0.3,0.5-0.4c0.4-0.3,0.9-0.6,1.3-1
      c0.1-0.1,0.2-0.1,0.3-0.2l0.9-0.8l0,0C80.8,43.4,84.3,36.1,84.3,28.1z M31.3,28.1C31.3,14,42.7,2.6,56.8,2.6S82.3,14,82.3,28.1
      c0,7.6-3.3,14.4-8.6,19.1c-0.3-0.2-0.6-0.4-0.9-0.5l-8.5-4.2c-0.8-0.4-1.2-1.1-1.2-2v-3c0.2-0.2,0.4-0.5,0.6-0.8
      c1.1-1.5,2-3.3,2.6-5.1c1.3-0.6,2.1-1.9,2.1-3.3v-3.5c0-0.9-0.3-1.7-0.9-2.4v-4.7c0.1-0.5,0.2-3.4-1.9-5.9c-1.8-2.1-4.8-3.2-8.9-3.2
      s-7,1.1-8.9,3.2c-2.1,2.4-1.9,5.3-1.9,5.9v4.7c-0.6,0.7-0.9,1.5-0.9,2.4v3.5c0,1.1,0.5,2.1,1.3,2.8c0.8,3.2,2.5,5.6,3.1,6.4v2.9
      c0,0.8-0.4,1.6-1.2,2l-7.9,4.3c-0.3,0.1-0.5,0.3-0.8,0.5C34.6,42.4,31.3,35.6,31.3,28.1z M71.7,48.7c-0.3,0.3-0.7,0.5-1.1,0.7
      c-0.2,0.1-0.3,0.2-0.5,0.3c-0.5,0.3-1,0.6-1.4,0.8c-0.1,0.1-0.2,0.1-0.3,0.2c-1.1,0.6-2.3,1.1-3.5,1.5c0,0-0.1,0-0.1,0
      c-0.6,0.2-1.3,0.4-1.9,0.6c0,0,0,0,0,0c-0.6,0.2-1.3,0.3-2,0.4c0,0,0,0-0.1,0c-0.6,0.1-1.2,0.2-1.9,0.2c-0.1,0-0.2,0-0.3,0
      c-0.6,0-1.2,0.1-1.9,0.1c-0.6,0-1.3,0-1.9-0.1c-0.1,0-0.2,0-0.3,0c-0.6-0.1-1.3-0.1-1.9-0.2c0,0-0.1,0-0.1,0c-1.3-0.2-2.6-0.5-3.9-1
      c0,0-0.1,0-0.1,0c-0.6-0.2-1.3-0.5-1.9-0.7c0,0,0,0,0,0c-0.6-0.2-1.1-0.5-1.7-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-1-0.6-1.5-0.9
      c-0.1-0.1-0.3-0.2-0.4-0.3c-0.5-0.3-0.9-0.6-1.3-0.9c0,0-0.1-0.1-0.1-0.1c0,0,0.1,0,0.1-0.1l7.9-4.3c1.4-0.7,2.2-2.2,2.2-3.7l0-3.6
      l-0.2-0.3c0,0-2.2-2.7-3-6.2l-0.1-0.4l-0.3-0.2c-0.5-0.3-0.8-0.8-0.8-1.4v-3.5c0-0.5,0.2-0.9,0.6-1.2l0.3-0.3v-5.6l0-0.1
      c0,0-0.3-2.4,1.4-4.4c1.4-1.6,3.9-2.5,7.4-2.5c3.4,0,5.9,0.8,7.3,2.5c1.7,1.9,1.4,4.4,1.4,4.4l0,5.7l0.3,0.3
      c0.4,0.3,0.6,0.8,0.6,1.2v3.5c0,0.7-0.5,1.4-1.2,1.6l-0.5,0.2l-0.2,0.5c-0.6,1.8-1.4,3.5-2.5,5c-0.3,0.4-0.5,0.7-0.7,0.9l-0.2,0.3
      v3.7c0,1.6,0.9,3.1,2.3,3.8l8.5,4.2c0.1,0,0.1,0.1,0.2,0.1C72,48.6,71.8,48.7,71.7,48.7z"/>

      <g>
        <g>
          <path d="M22.3,7.4h-6v-6c0-0.5-0.4-0.9-0.9-0.9H8.7C8.2,0.6,7.8,1,7.8,1.4v6h-6C1.4,7.4,1,7.8,1,8.3v6.8c0,0.5,0.4,0.9,0.9,0.9h6
            v6c0,0.5,0.4,0.9,0.9,0.9h6.8c0.5,0,0.9-0.4,0.9-0.9v-6h6c0.5,0,0.9-0.4,0.9-0.9V8.3C23.1,7.8,22.7,7.4,22.3,7.4z M21.5,14.2
            L21.5,14.2h-6c-0.5,0-0.9,0.4-0.9,0.9v6H9.5v-6c0-0.5-0.4-0.9-0.9-0.9h-6V9.1h6c0.5,0,0.9-0.4,0.9-0.9v-6h5.2v6
            c0,0.5,0.4,0.9,0.9,0.9h6V14.2z"/>
        </g>
      </g>
    `,
  },
  userSpecialist: {
    viewBox: '0 0 85.5 56.2',
    src: svg`
      <path d="M84.3,28.1C84.3,12.9,72,0.6,56.8,0.6S29.3,12.9,29.3,28.1c0,8,3.4,15.2,8.9,20.3l0,0l0.9,0.8c0.1,0,0.1,0.1,0.2,0.1
      c0.5,0.4,1,0.8,1.5,1.1c0.2,0.1,0.3,0.2,0.5,0.3c0.5,0.4,1.1,0.7,1.6,1c0.1,0.1,0.2,0.1,0.4,0.2c0.6,0.3,1.2,0.7,1.9,1
      c0,0,0.1,0,0.1,0.1c2.1,1,4.3,1.7,6.7,2.1c0.1,0,0.1,0,0.2,0c0.7,0.1,1.5,0.2,2.2,0.3c0.1,0,0.2,0,0.3,0c0.7,0.1,1.5,0.1,2.2,0.1
      s1.5,0,2.2-0.1c0.1,0,0.2,0,0.3,0c0.7-0.1,1.5-0.2,2.2-0.3c0.1,0,0.1,0,0.2,0c2.3-0.4,4.5-1.1,6.6-2.1c0.1,0,0.2-0.1,0.2-0.1
      c0.6-0.3,1.2-0.6,1.8-0.9c0.1-0.1,0.3-0.2,0.4-0.3c0.5-0.3,1.1-0.6,1.6-1c0.2-0.1,0.4-0.3,0.5-0.4c0.4-0.3,0.9-0.6,1.3-1
      c0.1-0.1,0.2-0.1,0.3-0.2l0.9-0.8l0,0C80.8,43.4,84.3,36.1,84.3,28.1z M31.3,28.1C31.3,14,42.7,2.6,56.8,2.6S82.3,14,82.3,28.1
      c0,7.6-3.3,14.4-8.6,19.1c-0.3-0.2-0.6-0.4-0.9-0.5l-8.5-4.2c-0.8-0.4-1.2-1.1-1.2-2v-3c0.2-0.2,0.4-0.5,0.6-0.8
      c1.1-1.5,2-3.3,2.6-5.1c1.3-0.6,2.1-1.9,2.1-3.3v-3.5c0-0.9-0.3-1.7-0.9-2.4v-4.7c0.1-0.5,0.2-3.4-1.9-5.9c-1.8-2.1-4.8-3.2-8.9-3.2
      s-7,1.1-8.9,3.2c-2.1,2.4-1.9,5.3-1.9,5.9v4.7c-0.6,0.7-0.9,1.5-0.9,2.4v3.5c0,1.1,0.5,2.1,1.3,2.8c0.8,3.2,2.5,5.6,3.1,6.4v2.9
      c0,0.8-0.4,1.6-1.2,2l-7.9,4.3c-0.3,0.1-0.5,0.3-0.8,0.5C34.6,42.4,31.3,35.6,31.3,28.1z M71.7,48.7c-0.3,0.3-0.7,0.5-1.1,0.7
      c-0.2,0.1-0.3,0.2-0.5,0.3c-0.5,0.3-1,0.6-1.4,0.8c-0.1,0.1-0.2,0.1-0.3,0.2c-1.1,0.6-2.3,1.1-3.5,1.5h-0.1
      c-0.6,0.2-1.3,0.4-1.9,0.6l0,0c-0.6,0.2-1.3,0.3-2,0.4c0,0,0,0-0.1,0c-0.6,0.1-1.2,0.2-1.9,0.2c-0.1,0-0.2,0-0.3,0
      c-0.6,0-1.2,0.1-1.9,0.1c-0.6,0-1.3,0-1.9-0.1c-0.1,0-0.2,0-0.3,0c-0.6-0.1-1.3-0.1-1.9-0.2h-0.1c-1.3-0.2-2.6-0.5-3.9-1h-0.1
      c-0.6-0.2-1.3-0.5-1.9-0.7l0,0c-0.6-0.2-1.1-0.5-1.7-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-1-0.6-1.5-0.9c-0.1-0.1-0.3-0.2-0.4-0.3
      c-0.5-0.3-0.9-0.6-1.3-0.9l-0.1-0.1c0,0,0.1,0,0.1-0.1l7.9-4.3c1.4-0.7,2.2-2.2,2.2-3.7v-3.6l-0.2-0.3c0,0-2.2-2.7-3-6.2l-0.1-0.4
      L48,29.6c-0.5-0.3-0.8-0.8-0.8-1.4v-3.5c0-0.5,0.2-0.9,0.6-1.2l0.3-0.3v-5.6v-0.1c0,0-0.3-2.4,1.4-4.4c1.4-1.6,3.9-2.5,7.4-2.5
      c3.4,0,5.9,0.8,7.3,2.5c1.7,1.9,1.4,4.4,1.4,4.4v5.7l0.3,0.3c0.4,0.3,0.6,0.8,0.6,1.2v3.5c0,0.7-0.5,1.4-1.2,1.6L64.8,30l-0.2,0.5
      c-0.6,1.8-1.4,3.5-2.5,5c-0.3,0.4-0.5,0.7-0.7,0.9l-0.2,0.3v3.7c0,1.6,0.9,3.1,2.3,3.8l8.5,4.2c0.1,0,0.1,0.1,0.2,0.1
      C72,48.6,71.8,48.7,71.7,48.7z"/>

      <g>
        <g>
          <g>
            <path d="M18.1,2.5h-3.4v2.1h2.3v4c0,3.5-2.9,6.4-6.4,6.4s-6.4-2.9-6.4-6.4v-4h2.3V2.5H3.2C2.7,2.5,2.2,3,2.2,3.6v5.1
              c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5V3.6C19.2,3,18.7,2.5,18.1,2.5z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M22.3,18v5c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3v-7H9.5v7c0,4.1,3.3,7.5,7.5,7.5c4.1,0,7.5-3.3,7.5-7.5v-5L22.3,18
              L22.3,18z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M23.4,11.2c-2.2,0-3.9,1.8-3.9,3.9c0,2.2,1.8,3.9,3.9,3.9s3.9-1.8,3.9-3.9C27.3,12.9,25.5,11.2,23.4,11.2z M23.4,16.9
              c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8S24.4,16.9,23.4,16.9z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M6.5,1.4C6,1.4,5.5,1.8,5.5,2.4v2.3c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1V2.4C7.6,1.8,7.1,1.4,6.5,1.4z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M14.8,1.4c-0.6,0-1.1,0.5-1.1,1.1v2.3c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1V2.4C15.8,1.8,15.4,1.4,14.8,1.4z"/>
          </g>
        </g>
      </g>
    `,
  },
  userStaff: {
    viewBox: '0 0 85.5 56.2',
    src: svg`
      <path d="M84.3,28.1C84.3,12.9,72,0.6,56.8,0.6S29.3,12.9,29.3,28.1c0,8,3.4,15.2,8.9,20.3l0,0l0.9,0.8c0.1,0,0.1,0.1,0.2,0.1
        c0.5,0.4,1,0.8,1.5,1.1c0.2,0.1,0.3,0.2,0.5,0.3c0.5,0.4,1.1,0.7,1.6,1c0.1,0.1,0.2,0.1,0.4,0.2c0.6,0.3,1.2,0.7,1.9,1
        c0,0,0.1,0,0.1,0.1c2.1,1,4.3,1.7,6.7,2.1c0.1,0,0.1,0,0.2,0c0.7,0.1,1.5,0.2,2.2,0.3c0.1,0,0.2,0,0.3,0c0.7,0.1,1.5,0.1,2.2,0.1
        s1.5,0,2.2-0.1c0.1,0,0.2,0,0.3,0c0.7-0.1,1.5-0.2,2.2-0.3c0.1,0,0.1,0,0.2,0c2.3-0.4,4.5-1.1,6.6-2.1c0.1,0,0.2-0.1,0.2-0.1
        c0.6-0.3,1.2-0.6,1.8-0.9c0.1-0.1,0.3-0.2,0.4-0.3c0.5-0.3,1.1-0.6,1.6-1c0.2-0.1,0.4-0.3,0.5-0.4c0.4-0.3,0.9-0.6,1.3-1
        c0.1-0.1,0.2-0.1,0.3-0.2l0.9-0.8l0,0C80.8,43.4,84.3,36.1,84.3,28.1z M31.3,28.1C31.3,14,42.7,2.6,56.8,2.6S82.3,14,82.3,28.1
        c0,7.6-3.3,14.4-8.6,19.1c-0.3-0.2-0.6-0.4-0.9-0.5l-8.5-4.2c-0.8-0.4-1.2-1.1-1.2-2v-3c0.2-0.2,0.4-0.5,0.6-0.8
        c1.1-1.5,2-3.3,2.6-5.1c1.3-0.6,2.1-1.9,2.1-3.3v-3.5c0-0.9-0.3-1.7-0.9-2.4v-4.7c0.1-0.5,0.2-3.4-1.9-5.9c-1.8-2.1-4.8-3.2-8.9-3.2
        s-7,1.1-8.9,3.2c-2.1,2.4-1.9,5.3-1.9,5.9v4.7c-0.6,0.7-0.9,1.5-0.9,2.4v3.5c0,1.1,0.5,2.1,1.3,2.8c0.8,3.2,2.5,5.6,3.1,6.4v2.9
        c0,0.8-0.4,1.6-1.2,2l-7.9,4.3c-0.3,0.1-0.5,0.3-0.8,0.5C34.6,42.4,31.3,35.6,31.3,28.1z M71.7,48.7c-0.3,0.3-0.7,0.5-1.1,0.7
        c-0.2,0.1-0.3,0.2-0.5,0.3c-0.5,0.3-1,0.6-1.4,0.8c-0.1,0.1-0.2,0.1-0.3,0.2c-1.1,0.6-2.3,1.1-3.5,1.5h-0.1
        c-0.6,0.2-1.3,0.4-1.9,0.6l0,0c-0.6,0.2-1.3,0.3-2,0.4c0,0,0,0-0.1,0c-0.6,0.1-1.2,0.2-1.9,0.2c-0.1,0-0.2,0-0.3,0
        c-0.6,0-1.2,0.1-1.9,0.1c-0.6,0-1.3,0-1.9-0.1c-0.1,0-0.2,0-0.3,0c-0.6-0.1-1.3-0.1-1.9-0.2h-0.1c-1.3-0.2-2.6-0.5-3.9-1h-0.1
        c-0.6-0.2-1.3-0.5-1.9-0.7l0,0c-0.6-0.2-1.1-0.5-1.7-0.8c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-1-0.6-1.5-0.9c-0.1-0.1-0.3-0.2-0.4-0.3
        c-0.5-0.3-0.9-0.6-1.3-0.9l-0.1-0.1c0,0,0.1,0,0.1-0.1l7.9-4.3c1.4-0.7,2.2-2.2,2.2-3.7v-3.6l-0.2-0.3c0,0-2.2-2.7-3-6.2l-0.1-0.4
        L48,29.6c-0.5-0.3-0.8-0.8-0.8-1.4v-3.5c0-0.5,0.2-0.9,0.6-1.2l0.3-0.3v-5.6v-0.1c0,0-0.3-2.4,1.4-4.4c1.4-1.6,3.9-2.5,7.4-2.5
        c3.4,0,5.9,0.8,7.3,2.5c1.7,1.9,1.4,4.4,1.4,4.4v5.7l0.3,0.3c0.4,0.3,0.6,0.8,0.6,1.2v3.5c0,0.7-0.5,1.4-1.2,1.6L64.8,30l-0.2,0.5
        c-0.6,1.8-1.4,3.5-2.5,5c-0.3,0.4-0.5,0.7-0.7,0.9l-0.2,0.3v3.7c0,1.6,0.9,3.1,2.3,3.8l8.5,4.2c0.1,0,0.1,0.1,0.2,0.1
        C72,48.6,71.8,48.7,71.7,48.7z"/>

      <path d="M13.4,18.4c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l2.7-2.7c0.3-0.3,0.3-0.8,0-1.1c-0.3-0.3-0.8-0.3-1.1,0l-2.2,2.2
        l-1-1c-0.3-0.3-0.8-0.3-1.1,0c-0.3,0.3-0.3,0.8,0,1.1L13.4,18.4z"/>

      <path d="M14.5,22.6c3.3,0,6-2.7,6-6s-2.7-6-6-6c-3.3,0-6,2.7-6,6S11.2,22.6,14.5,22.6z M14.5,12.1c2.5,0,4.5,2,4.5,4.5
        S17,21,14.5,21S10,19,10,16.6S12,12.1,14.5,12.1z"/>

      <path d="M24.5,2.2h-1.4V1.4c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v0.9h-1.5V1.4c0-0.4-0.3-0.8-0.8-0.8
        c-0.4,0-0.8,0.3-0.8,0.8v0.9h-8.3V1.4c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v0.9H7.3V1.4c0-0.4-0.3-0.8-0.8-0.8
        c-0.4,0-0.8,0.3-0.8,0.8v0.9H4.4C3.1,2.2,2,3.3,2,4.6v19.1c0,1.3,1.1,2.4,2.4,2.4h20.1c1.3,0,2.4-1.1,2.4-2.4V4.6
        C27,3.3,25.9,2.2,24.5,2.2z M25.5,23.7c0,0.5-0.4,0.9-0.9,0.9H4.4c-0.5,0-0.9-0.4-0.9-0.9V8.5h21.9V23.7z M3.5,4.6
        c0-0.5,0.4-0.9,0.9-0.9h1.4v0.9c0,0.4,0.3,0.8,0.8,0.8C7,5.3,7.3,5,7.3,4.6V3.7h1.5v0.9c0,0.4,0.3,0.8,0.8,0.8
        c0.4,0,0.8-0.3,0.8-0.8V3.7h8.3v0.9c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8V3.7h1.5v0.9c0,0.4,0.3,0.8,0.8,0.8
        c0.4,0,0.8-0.3,0.8-0.8V3.7h1.4c0.5,0,0.9,0.4,0.9,0.9V7H3.5V4.6z"/>
    `,
  },
  userAdmin: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <rect fill="none" height="24" width="24"/>
      </g>

      <g>
        <g>
          <path d="M17,11c0.34,0,0.67,0.04,1,0.09V6.27L10.5,3L3,6.27v4.91c0,4.54,3.2,8.79,7.5,9.82c0.55-0.13,1.08-0.32,1.6-0.55 C11.41,19.47,11,18.28,11,17C11,13.69,13.69,11,17,11z"/>
          <path d="M17,13c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4s4-1.79,4-4C21,14.79,19.21,13,17,13z M17,14.38c0.62,0,1.12,0.51,1.12,1.12 s-0.51,1.12-1.12,1.12s-1.12-0.51-1.12-1.12S16.38,14.38,17,14.38z M17,19.75c-0.93,0-1.74-0.46-2.24-1.17 c0.05-0.72,1.51-1.08,2.24-1.08s2.19,0.36,2.24,1.08C18.74,19.29,17.93,19.75,17,19.75z"/>
        </g>
      </g>
    `,
  },
  visible: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
    `,
  },
  visibilityOff: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
    `,
  },
  void: {
    viewBox: '2 2 20 20',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>
    `,
  },
  voidClaim: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M 12 2 C 6.48 2 2 6.48 2 12 s 4.48 10 10 10 s 10 -4.48 10 -10 S 17.52 2 12 2 Z M 4 12 c 0 -4.42 3.58 -8 8 -8 c 1.85 0 3.55 0.63 4.9 1.69 L 5.69 16.9 C 4.63 15.55 4 13.85 4 12 Z m 8 8 c -1.85 0 -3.55 -0.63 -4.9 -1.69 L 18.31 7.1 C 19.37 8.45 20 10.15 20 12 c 0 4.42 -3.58 8 -8 8 Z"/>
    `,
  },
  wallet: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.37-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"/>
      <circle cx="16" cy="12" r="1.5"/>
    `,
  },
  warning: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
    `,
  },
  zoomIn: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
      <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>
    `,
  },
  zoomOut: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"/>
    `,
  },
  flashAuto: {
    viewBox: '0 0 24 24',
    src: svg`
      <g transform="scale(.5)">
        <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/>
        <path d="M27.75 22 34.5 4h2.2l6.85 18h-2.6l-1.65-4.8h-7.25l-1.7 4.8Zm5.05-6.9h5.65L35.7 7.3h-.1ZM12 46V28H6V4h20l-8 18h8Z"/>
      </g>
    `,
  },
  autoPoint: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"/>
    `,
  },
  restore: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M12,5V2L8,6l4,4V7c3.31,0,6,2.69,6,6c0,2.97-2.17,5.43-5,5.91v2.02c3.95-0.49,7-3.85,7-7.93C20,8.58,16.42,5,12,5z"/>
      <path d="M6,13c0-1.65,0.67-3.15,1.76-4.24L6.34,7.34C4.9,8.79,4,10.79,4,13c0,4.08,3.05,7.44,7,7.93v-2.02 C8.17,18.43,6,15.97,6,13z"/>
    `,
  },
  firstDoubleArrow: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <polygon points="17.59,18 19,16.59 14.42,12 19,7.41 17.59,6 11.59,12"/>
        <polygon points="11,18 12.41,16.59 7.83,12 12.41,7.41 11,6 5,12"/>
      </g>
    `,
  },
  lastDoubleArrow: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <polygon points="6.41,6 5,7.41 9.58,12 5,16.59 6.41,18 12.41,12"/>
        <polygon points="13,6 11.59,7.41 16.17,12 11.59,16.59 13,18 19,12"/>
      </g>
    `,
  },
  nextArrow: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
      </g>
    `,
  },
  previousArrow: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
      </g>
    `,
  },
  zoomReset: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
      </g>
    `,
  },
  rotateClockwise: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path d="M18,13c0,3.3-2.7,6-6,6s-6-2.7-6-6s2.7-6,6-6v4l5-5l-5-5v4c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8H18z"/>
      </g>
    `,
  },
  rotateCounterClockwise: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path d="M12,5V1L7,6l5,5V7c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6H4c0,4.4,3.6,8,8,8s8-3.6,8-8S16.4,5,12,5z"/>
      </g>
    `,
  },
  overrideScrubbingErrors: {
    viewBox: '0 0 24 24',
    src: svg`
      <g>
        <path d="M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"/>
      </g>
    `,
  },
  placeholder: {
    viewBox: '0 0 273 184',
    src: svg`
    <path d="M 91.736 55.250 C 88.412 57.774, 88 61.877, 88 92.416 C 88 123.631, 88.482 128.117, 92.039 130.021 C 93.152 130.617, 110.945 131, 137.480 131 L 181.091 131 183.545 128.545 L 186 126.091 186 92.680 C 186 60.394, 185.930 59.181, 183.927 56.635 L 181.855 54 137.619 54 C 103.774 54, 92.996 54.294, 91.736 55.250 M 95.454 61.260 C 95.188 61.953, 95.090 76.465, 95.235 93.510 L 95.500 124.500 137.250 124.761 L 179 125.022 179 92.511 L 179 60 137.469 60 C 104.994 60, 95.832 60.275, 95.454 61.260 M 105.656 68.133 C 103.138 69.596, 101.069 74.908, 101.710 78.261 C 102.366 81.694, 107.327 86, 110.626 86 C 116.311 86, 121 81.267, 121 75.530 C 121 74.223, 119.835 71.769, 118.411 70.077 C 116.272 67.534, 115.100 67.005, 111.661 67.030 C 109.372 67.047, 106.670 67.543, 105.656 68.133 M 138.766 87.724 L 126.043 100.448 122.009 96.508 L 117.975 92.569 109.487 101.013 C 101.480 108.979, 101 109.697, 101 113.728 L 101 118 137 118 L 173 118 173 106.732 L 173 95.464 162.733 85.232 C 157.086 79.604, 152.246 75, 151.978 75 C 151.710 75, 145.764 80.726, 138.766 87.724" stroke="none" fill="#bbbcc2" fill-rule="evenodd"/>
    <path d="M -0 92.004 L -0 184.007 136.750 183.754 L 273.500 183.500 273.755 91.750 L 274.010 0 137.005 0 L 0 0 -0 92.004 M 0.479 92.500 C 0.479 143.100, 0.601 163.947, 0.750 138.826 C 0.898 113.705, 0.898 72.305, 0.750 46.826 C 0.601 21.347, 0.479 41.900, 0.479 92.500 M 91.736 55.250 C 88.412 57.774, 88 61.877, 88 92.416 C 88 123.631, 88.482 128.117, 92.039 130.021 C 93.152 130.617, 110.945 131, 137.480 131 L 181.091 131 183.545 128.545 L 186 126.091 186 92.680 C 186 60.394, 185.930 59.181, 183.927 56.635 L 181.855 54 137.619 54 C 103.774 54, 92.996 54.294, 91.736 55.250 M 95.454 61.260 C 95.188 61.953, 95.090 76.465, 95.235 93.510 L 95.500 124.500 137.250 124.761 L 179 125.022 179 92.511 L 179 60 137.469 60 C 104.994 60, 95.832 60.275, 95.454 61.260 M 105.656 68.133 C 103.138 69.596, 101.069 74.908, 101.710 78.261 C 102.366 81.694, 107.327 86, 110.626 86 C 116.311 86, 121 81.267, 121 75.530 C 121 74.223, 119.835 71.769, 118.411 70.077 C 116.272 67.534, 115.100 67.005, 111.661 67.030 C 109.372 67.047, 106.670 67.543, 105.656 68.133 M 138.766 87.724 L 126.043 100.448 122.009 96.508 L 117.975 92.569 109.487 101.013 C 101.480 108.979, 101 109.697, 101 113.728 L 101 118 137 118 L 173 118 173 106.732 L 173 95.464 162.733 85.232 C 157.086 79.604, 152.246 75, 151.978 75 C 151.710 75, 145.764 80.726, 138.766 87.724" stroke="none" fill="#ebebf3" fill-rule="evenodd"/>
    `,
  },
  priceCheck: {
    viewBox: '0 0 24 24',
    src: svg`
    <g>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
    </g>
    `,
  },
  merge: {
    viewBox: '0 0 24 24',
    src: svg`
    <g>
      <path d="M3 6.4L4.4 5L9.25 9.825C9.63333 10.2083 10.0667 10.5 10.55 10.7C11.0333 10.9 11.5417 11 12.075 11H17.175L15.6 9.4L17 8L21 12L17 16L15.6 14.6L17.175 13H12.075C11.5417 13 11.0333 13.1 10.55 13.3C10.0667 13.5 9.63333 13.7917 9.25 14.175L4.4 19L3 17.6L8.6 12L3 6.4Z"/>
    </g>
    `,
  },
  correctClaim: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    `,
  },
  export: {
    viewBox: '0 -960 960 960',
    src: svg`
      <path d="m648-140 112-112v92h40v-160H640v40h92L620-168l28 28Zm-448 20q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Z"/>
    `,
  },
  matchCharge: {
    viewBox: '0 0 24 24',
    src: svg`
      <rect fill="none" width="24" height="24"/>
      <rect x="2" y="7" width="9" height="2"/>
      <rect x="2" y="15" width="9" height="2"/>
      <path d="M17.6,11c-2-0.5-2.7-1.1-2.7-1.9c0-1,0.9-1.7,2.4-1.7c1.6,0,2.2,0.8,2.3,1.9h2c-0.1-1.5-1-3-2.9-3.4v-2H16v1.9c-1.7,0.4-3.2,1.5-3.2,3.3c0,2.1,1.7,3.1,4.2,3.7c2.3,0.5,2.7,1.3,2.7,2.2c0,0.6-0.4,1.6-2.4,1.6c-1.9,0-2.6-0.8-2.7-1.9h-2c0.1,2,1.6,3.1,3.3,3.5v2h2.7v-1.9c1.8-0.3,3.2-1.4,3.2-3.2C21.8,12.4,19.7,11.5,17.6,11z"/>
    `,
  },
  claims: {
    viewBox: '0 0 24 24',
    src: svg`
        <g><rect fill="none" height="24" width="24"/></g>
        <path d="M20,3H4C2.9,3,2,3.9,2,5v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V5 C22,3.9,21.1,3,20,3z M10,17H5v-2h5V17z M10,13H5v-2h5V13z M10,9H5V7h5V9z M14.82,15L12,12.16l1.41-1.41l1.41,1.42L17.99,9 l1.42,1.42L14.82,15z" fill-rule="evenodd"/>
    `,
  },
  eraEob: {
    viewBox: '0 0 24 24',
    src: svg`
        <g><rect fill="none" height="24" width="24"/></g>
        <path d="M14,2H6C4.9,2,4,2.9,4,4v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v4h5v12H6z M11,19h2v-1h1 c0.55,0,1-0.45,1-1v-3c0-0.55-0.45-1-1-1h-3v-1h4v-2h-2V9h-2v1h-1c-0.55,0-1,0.45-1,1v3c0,0.55,0.45,1,1,1h3v1H9v2h2V19z"/>
    `,
  },
  patientFlow: {
    viewBox: '0 0 24 24',
    src: svg`
        <g><rect fill="none" height="24" width="24"/></g>
        <path d="M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"/>
    `,
  },
  rooms: {
    viewBox: '0 0 24 24',
    src: svg`
        <g><rect fill="none" height="24" width="24"/></g>
        <path d="M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z"/>
        `,
  },
  revAccel: {
    viewBox: '0 0 24 24',
    src: svg`
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"/>
    `,
  },
  scrubClaim: {
    viewBox: '0 0 512 512',
    src: svg`
    <path d="m484.05 301h-456.1l-27.95 150h57.7l18.59-92.94 29.42 5.88-17.41 87.06h59.4l18.59-92.94 29.42 5.88-17.41 87.06h62.7v-90h30v90h62.7l-17.41-87.06 29.42-5.88 18.59 92.94h59.4l-17.41-87.06 29.42-5.88 18.59 92.94h57.7z"/>
    <path d="m481 226v45h-448.48c6.96-34.19 37.27-60 73.48-60h283.49c-6.97-34.19-37.27-60-73.49-60h-135c-41.35 0-75-33.65-75-75v-15h210c90.98 0 165 74.02 165 165z"/>
    `,
  },
  addLink: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0 0h24v24H0" fill="none"/>
    <path d="M8 11h8v2H8zm12.1 1H22c0-2.76-2.24-5-5-5h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1zM3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM19 12h-2v3h-3v2h3v3h2v-3h3v-2h-3z"/>
    `,
  },
  fixClaimError: {
    viewBox: '0 0 24 24',
    src: svg`
      <g><rect height="8.48" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -6.8717 17.6255)" width="3" x="16.34" y="12.87"/>
      <path d="M17.5,10c1.93,0,3.5-1.57,3.5-3.5c0-0.58-0.16-1.12-0.41-1.6l-2.7,2.7L16.4,6.11l2.7-2.7C18.62,3.16,18.08,3,17.5,3 C15.57,3,14,4.57,14,6.5c0,0.41,0.08,0.8,0.21,1.16l-1.85,1.85l-1.78-1.78l0.71-0.71L9.88,5.61L12,3.49 c-1.17-1.17-3.07-1.17-4.24,0L4.22,7.03l1.41,1.41H2.81L2.1,9.15l3.54,3.54l0.71-0.71V9.15l1.41,1.41l0.71-0.71l1.78,1.78 l-7.41,7.41l2.12,2.12L16.34,9.79C16.7,9.92,17.09,10,17.5,10z"/></g>
    `,
  },
  swapVerticalCircle: {
    viewBox: '0 0 24 24',
    src: svg`
      <g id="swap-vertical-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"></path></g>
    `,
  },
  forwardArrow: {
    viewBox: '0 -960 960 960',
    src: svg`
    <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/>
    `,
  },
  featureAccess: {
    viewBox: '0 0 24 24',
    src: svg`
    <g>
      <path d="M23.136,18.855h0a2.9,2.9,0,0,1-1.991-1.991h0a1.191,1.191,0,0,0-2.29,0h0a2.9,2.9,0,0,1-1.991,1.991h0a1.191,1.191,0,0,0,0,2.29h0a2.9,2.9,0,0,1,1.991,1.991h0a1.191,1.191,0,0,0,2.29,0h0a2.9,2.9,0,0,1,1.991-1.991h0A1.191,1.191,0,0,0,23.136,18.855Z"/><path d="M15.137,2.855h0A2.9,2.9,0,0,1,13.145.864h0a1.191,1.191,0,0,0-2.29,0h0A2.9,2.9,0,0,1,8.864,2.855h0a1.191,1.191,0,0,0,0,2.29h0a2.9,2.9,0,0,1,1.991,1.991h0a1.191,1.191,0,0,0,2.29,0h0a2.9,2.9,0,0,1,1.991-1.991h0A1.191,1.191,0,0,0,15.137,2.855Z"/><path d="M.863,21.145h0a2.9,2.9,0,0,1,1.991,1.991h0a1.191,1.191,0,0,0,2.29,0h0a2.9,2.9,0,0,1,1.991-1.991h0a1.191,1.191,0,0,0,0-2.29h0a2.9,2.9,0,0,1-1.991-1.991h0a1.191,1.191,0,0,0-2.29,0h0A2.9,2.9,0,0,1,.864,18.855h0A1.191,1.191,0,0,0,.863,21.145Z"/><circle cx="5.5" cy="13.5" r="1.5"/><circle cx="1.5" cy="9.5" r="1.5"/><circle cx="5.5" cy="5.5" r="1.5"/><circle cx="1.5" cy="1.5" r="1.5"/><circle cx="22.5" cy="13.5" r="1.5"/><circle cx="18.5" cy="9.5" r="1.5"/><circle cx="22.5" cy="5.5" r="1.5"/><circle cx="18.5" cy="1.5" r="1.5"/><circle cx="14.5" cy="22.5" r="1.5"/><circle cx="10.5" cy="18.5" r="1.5"/><circle cx="14.5" cy="14.5" r="1.5"/><circle cx="10.5" cy="10.5" r="1.5"/>
    </g>
    `,
  },
  save: {
    viewBox: '0 -960 960 960',
    src: svg`
      <path d="M840-680v480q0 33-23.5 56.5T760-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h480l160 160ZM480-240q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM240-560h360v-160H240v160Z"/>
    `,
  },
  celebration: {
    viewBox: '0 -960 960 960',
    src: svg`<path d="m80-80 200-560 360 360L80-80Zm502-378-42-42 224-224q32-32 77-32t77 32l24 24-42 42-24-24q-14-14-35-14t-35 14L582-458ZM422-618l-42-42 24-24q14-14 14-34t-14-34l-26-26 42-42 26 26q32 32 32 76t-32 76l-24 24Zm80 80-42-42 144-144q14-14 14-35t-14-35l-64-64 42-42 64 64q32 32 32 77t-32 77L502-538Zm160 160-42-42 64-64q32-32 77-32t77 32l64 64-42 42-64-64q-14-14-35-14t-35 14l-64 64Z"/>`,
  },
  ai: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"/>`,
  },
  followUp: {
    viewBox: '0 0 24 24',
    src: svg`<path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>`,
  },
  completeFollowUp: {
    viewBox: '0 0 24 24',
    src: svg`<g><path d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M10.94,18L7.4,14.46l1.41-1.41 l2.12,2.12l4.24-4.24l1.41,1.41L10.94,18z M13,9V3.5L18.5,9H13z"/></g>`,
  },
  security: {
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    src: svg`<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
              />`,
  },
  greenShieldCheckmark: {
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    src: svg`
    <path d="M12 2L3 5.5V11C3 16.5 6.8 21.7 12 23C17.2 21.7 21 16.5 21 11V5.5L12 2Z" fill="#4CAF50"/>
    <path d="M10 15.5L6.5 12L5.5 13L10 17.5L18.5 9L17.5 8L10 15.5Z" fill="white"/>
  `,
  },
  aiChartSummary: {
    viewBox: '0 0 24 24',
    src: svg`
    <g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><g><path d="M15,3H5C3.9,3,3.01,3.9,3.01,5L3,19c0,1.1,0.89,2,1.99,2H19c1.1,0,2-0.9,2-2V9L15,3z M8,17c-0.55,0-1-0.45-1-1s0.45-1,1-1 s1,0.45,1,1S8.55,17,8,17z M8,13c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S8.55,13,8,13z M8,9C7.45,9,7,8.55,7,8s0.45-1,1-1 s1,0.45,1,1S8.55,9,8,9z M14,10V4.5l5.5,5.5H14z"/></g></g>`,
  },
  aiScribe: {
    viewBox: '0 0 24 24',
    src: svg`
    <path d="M0 0h24v24H0z" fill="none"/><path d="M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"/>`,
  },
};
